/* Jerzify Mono — order tracker (globe + worker lookup). Config: window.JZTrack, set by sections/main-track-order.liquid */
(function(){
  var CFG = window.JZTrack || {};
  var WORKER = String(CFG.worker || '').replace(/\/+$/, '');
  var PROC = +CFG.proc || 5, SHIP = +CFG.ship || 18;
  var LOGOS = CFG.logos || {};

  /* ═══════════════════════════════════════
     GLOBE
  ═══════════════════════════════════════ */
  var cvs = document.getElementById('globeCanvas');
  if (!cvs) return;
  var ctx = cvs.getContext('2d');
  var SZ = 500, R = 247;
  /* Backing store follows the DISPLAYED size × devicePixelRatio (capped), so the 500-unit drawing
     stays crisp at 600px on desktop and on retina phones. All drawing code keeps 0–500 coordinates. */
  var KPX = 0;
  function fitCanvas(){
    var w = cvs.getBoundingClientRect().width || SZ;
    var k = Math.max(1, Math.min(2.4, (w / SZ) * (window.devicePixelRatio || 1)));
    k = Math.round(k * 4) / 4;
    if (k === KPX) return;
    KPX = k; cvs.width = SZ * k; cvs.height = SZ * k; ctx.setTransform(k, 0, 0, k, 0, 0);
  }
  fitCanvas();
  if ('ResizeObserver' in window) new ResizeObserver(fitCanvas).observe(cvs); else window.addEventListener('resize', fitCanvas);
  var userZoom = false;             /* true once the visitor zooms in → the globe takes over vertical touch too */   /* sphere ~fills the canvas circle → no gold gap-ring at the edge */
  var displayR = R, targetR = R;

  var rotX = 0.35, rotY = 0.98;
  var dragging = false, lastX = 0, lastY = 0;
  var lockedY = null, lockedX = null;
  var userMoved = false;            /* user dragged/zoomed → stop auto-centering until next track */
  var pinching = false, pinchDist = 0;
  var MINR = 0, MAXR = 0;           /* zoom bounds (set after R below) */
  var frame = 0;
  var planeProgress = 0, targetProgress = 0;
  var planePx = SZ/2, planePy = SZ/2;
  var planeVisible = false;
  var currentStage = -1;
  var currentData = null;
  var sameCountry = false;

  var ORIGIN = { lon: 113.3, lat: 23.1 };  /* flight origin — China sourcing hub (Guangzhou) */
  var HOME   = { lon: 35.5,  lat: 33.9 };  /* default globe view — Lebanon main HQ */
  var DEST   = null;
  var ARC    = [];
  /* Default view: settle on the Lebanon main HQ region and hold — no perpetual spin. */
  lockedY = HOME.lon * Math.PI/180;
  lockedX = HOME.lat * Math.PI/180;   /* +lat centers that latitude vertically */
  MINR = R; MAXR = R * 10;              /* zoom IN only (never shrink below full → no edge gap); ultra-deep max */

  /* ─── Cross-browser rounded rect (replaces ctx.roundRect which crashes Safari/older Chrome) ─── */
  function trkRoundRect(x,y,w,h,r){
    ctx.beginPath();
    ctx.moveTo(x+r,y);ctx.lineTo(x+w-r,y);ctx.arcTo(x+w,y,x+w,y+r,r);
    ctx.lineTo(x+w,y+h-r);ctx.arcTo(x+w,y+h,x+w-r,y+h,r);
    ctx.lineTo(x+r,y+h);ctx.arcTo(x,y+h,x,y+h-r,r);
    ctx.lineTo(x,y+r);ctx.arcTo(x,y,x+r,y,r);ctx.closePath();
  }

  /* ─── Orthographic projection using displayR ─── */
  function proj(lon, lat) {
    var la = lat*Math.PI/180, lo = lon*Math.PI/180;
    var cla=Math.cos(la), sla=Math.sin(la), dlo=lo-rotY;
    var z = sla*Math.sin(rotX) + cla*Math.cos(dlo)*Math.cos(rotX); // depth toward viewer
    return {
      x: SZ/2 + displayR*cla*Math.sin(dlo),
      y: SZ/2 - displayR*(sla*Math.cos(rotX) - cla*Math.cos(dlo)*Math.sin(rotX)),
      v: z > 0,
      z: z
    };
  }

  /* ─── Great circle arc ─── */
  function computeArc(p1, p2, n) {
    var pts=[], la1=p1.lat*Math.PI/180, lo1=p1.lon*Math.PI/180;
    var la2=p2.lat*Math.PI/180, lo2=p2.lon*Math.PI/180;
    var dot=Math.sin(la1)*Math.sin(la2)+Math.cos(la1)*Math.cos(la2)*Math.cos(lo2-lo1);
    var d=Math.acos(Math.max(-1,Math.min(1,dot)));
    for(var i=0;i<=n;i++){
      var t=i/n, sd=Math.sin(d)||0.0001;
      var A=Math.sin((1-t)*d)/sd, B=Math.sin(t*d)/sd;
      var x=A*Math.cos(la1)*Math.cos(lo1)+B*Math.cos(la2)*Math.cos(lo2);
      var y=A*Math.cos(la1)*Math.sin(lo1)+B*Math.cos(la2)*Math.sin(lo2);
      var z=A*Math.sin(la1)+B*Math.sin(la2);
      pts.push({lon:Math.atan2(y,x)*180/Math.PI, lat:Math.atan2(z,Math.sqrt(x*x+y*y))*180/Math.PI});
    }
    return pts;
  }

  /* ─── Coastlines: real Natural Earth 110m land, loaded from assets/globe-land.js.
     Each ring is stored flat [lon,lat,lon,lat,…] to save bytes — expand to pairs. ─── */
  function _expand(rings){
    return (rings||[]).map(function(f){
      var r=[]; for(var i=0;i<f.length;i+=2) r.push([f[i],f[i+1]]); return r;
    });
  }
  var LANDS = _expand(window.JZ_GLOBE_LAND);
  var ICE   = _expand(window.JZ_GLOBE_ICE);   /* Antarctica only */

  /* ── Fill-safe cell split ───────────────────────────────────────────────────
     Giant rings (Eurasia, the Americas, Antarctica) can have horizon crossings
     half a world apart — no per-crossing bridge is reliably correct, which is
     what painted the phantom wedges while rotating. So for FILLING we pre-split
     every ring into ≤60°×60° lon/lat cells (Sutherland–Hodgman). A small cell
     only ever crosses the horizon locally → its bridge arc is always short and
     correct. Strokes still use the ORIGINAL rings, so coastlines look identical. */
  function _clipHalf(ring, axis, bound, keepBelow){
    var out=[];
    for(var i=0;i<ring.length;i++){
      var a=ring[i], b=ring[(i+1)%ring.length];
      var av=a[axis], bv=b[axis];
      var ain = keepBelow ? av<=bound : av>=bound;
      var bin = keepBelow ? bv<=bound : bv>=bound;
      if(ain) out.push(a);
      if(ain!==bin){
        var t=(bound-av)/((bv-av)||1e-9);
        out.push(axis===0 ? [bound, a[1]+(b[1]-a[1])*t] : [a[0]+(b[0]-a[0])*t, bound]);
      }
    }
    return out;
  }
  /* Densify long straight cell edges so they hug the sphere when projected
     (neighbouring cells generate identical points → seams line up exactly). */
  function _densify(ring, step){
    var out=[];
    for(var i=0;i<ring.length;i++){
      var a=ring[i], b=ring[(i+1)%ring.length];
      out.push(a);
      var d=Math.max(Math.abs(b[0]-a[0]),Math.abs(b[1]-a[1]));
      var k=Math.floor(d/step);
      for(var j=1;j<=k;j++){var t=j/(k+1);out.push([a[0]+(b[0]-a[0])*t,a[1]+(b[1]-a[1])*t]);}
    }
    return out;
  }
  function _cellSplit(rings){
    var cells=[];
    rings.forEach(function(ring){
      var minLo=999,maxLo=-999,minLa=999,maxLa=-999;
      for(var i=0;i<ring.length;i++){
        var p=ring[i];
        if(p[0]<minLo)minLo=p[0]; if(p[0]>maxLo)maxLo=p[0];
        if(p[1]<minLa)minLa=p[1]; if(p[1]>maxLa)maxLa=p[1];
      }
      for(var lo=-180;lo<180;lo+=60){
        if(lo>maxLo||lo+60<minLo) continue;
        var c1=_clipHalf(ring,0,lo,false); if(c1.length<3) continue;
        c1=_clipHalf(c1,0,lo+60,true);     if(c1.length<3) continue;
        for(var la=-90;la<90;la+=60){
          if(la>maxLa||la+60<minLa) continue;
          var c2=_clipHalf(c1,1,la,false); if(c2.length<3) continue;
          c2=_clipHalf(c2,1,la+60,true);   if(c2.length<3) continue;
          cells.push(_densify(c2,4));
        }
      }
    });
    return cells;
  }
  var LAND_FILL = _cellSplit(LANDS);
  var ICE_FILL  = _cellSplit(ICE);
  /* Accurate per-country borders (Natural Earth 110m admin-0, 288 rings) — drawn as outlines on
     top of the land fill so every country sits in its exact place with real borders. */
  var COUNTRIES = _expand(window.JZ_GLOBE_COUNTRIES || []);
  var DESERTS = [];                            /* removed — clashed with real coastlines */

  /* ─── Rivers ─── */
  var RIVERS = [
    [[33,-1],[33,2],[33,5],[33,8],[33,12],[33,16],[32,19],[33,22],[33,25],[33,28],[31,30]],/* Nile */
    [[30,-1],[28,0],[26,0],[24,-1],[22,-1],[20,-2],[18,-4],[16,-4],[14,-4],[12,-5]],       /* Congo */
    [[-73,-5],[-70,-9],[-67,-10],[-63,-10],[-60,-8],[-57,-7],[-53,-6],[-50,-3],[-44,-2]],/* Amazon */
    [[0,13],[4,14],[8,14],[10,12],[9,9],[7,5]],                                            /* Niger */
  ];

  function drawRiver(pts){
    ctx.beginPath();var m=false;
    for(var i=0;i<pts.length;i++){
      var p=proj(pts[i][0],pts[i][1]);
      if(!p.v){m=false;continue;}
      if(!m){ctx.moveTo(p.x,p.y);m=true;}else{ctx.lineTo(p.x,p.y);}
    }
    ctx.strokeStyle='rgba(255,255,255,0.10)';ctx.lineWidth=0.8;ctx.stroke();
  }

  /* ─── City network ─── */
  /* Two Jerzify hubs: the Main HQ in Lebanon and the sourcing/fulfilment HQ in China. */
  var HQS = [
    {lon:35.37, lat:33.56, name:'JERZIFY HQ', sub:'SAIDA · LEBANON', main:true},
    {lon:113.3, lat:23.1, name:'JERZIFY CHINA', sub:'GUANGZHOU HUB', main:false},
  ];
  var CITIES = [
    {n:'Beirut',lon:35.5,lat:33.9},
    {n:'Dubai',lon:55.3,lat:25.2},{n:'Istanbul',lon:29.0,lat:41.0},
    {n:'Cairo',lon:31.2,lat:30.0},{n:'Moscow',lon:37.6,lat:55.8},
    {n:'Mumbai',lon:72.8,lat:19.1},{n:'Shanghai',lon:121.5,lat:31.2},
    {n:'London',lon:-0.1,lat:51.5},{n:'New York',lon:-74.0,lat:40.7},
    {n:'Sydney',lon:151.2,lat:-33.9},{n:'Riyadh',lon:46.7,lat:24.7},
    {n:'Frankfurt',lon:8.7,lat:50.1},{n:'Singapore',lon:103.8,lat:1.3},
  ];
  var CONNS=[[0,1],[0,2],[0,3],[0,4],[1,5],[1,10],[2,7],[2,11],[3,10],[4,7],[5,12],[6,12],[6,9],[7,11],[7,8],[8,0]];
  /* Country-name labels: a curated 'major' set is always shown; the rest appear when zoomed in.
     Built lazily from the ISO coordinate + name tables (defined later in this IIFE). */
  /* Curated tighter — the old 60+ set crowded Europe/Middle East into an overlapping
     mess at default zoom. Zooming in still reveals every country. */
  var MAJOR=new Set(['US','CA','MX','BR','AR','GB','FR','ES','PT','DE','IT','SE','NO','PL','UA','RU','TR','EG','MA','DZ','NG','KE','ZA','SA','AE','IQ','IR','IN','CN','JP','KR','TH','SG','ID','PH','AU']);
  var COUNTRY_LABELS=null;
  function buildCountryLabels(){
    COUNTRY_LABELS=[];
    for(var cc in ISO_COORD){
      if(cc==='LB')continue; /* Lebanon is covered by the HQ label */
      COUNTRY_LABELS.push({lon:ISO_COORD[cc][0],lat:ISO_COORD[cc][1],name:(INTL_CODE_NAMES[cc]||cc),major:MAJOR.has(cc)});
    }
  }

  /* ─── Country centroids ─── */
  var COUNTRY={
    'Lebanon':[35.5,33.9],'Syria':[38,35],'Jordan':[36,31],'Palestine':[35.2,31.9],
    'Cyprus':[33,35],'Iraq':[44,33],'Saudi Arabia':[45,24],'Kuwait':[48,29],
    'Qatar':[51,25],'United Arab Emirates':[54,24],'Oman':[57,22],'Yemen':[48,15],
    'Turkey':[35,39],'Egypt':[30,26],'Libya':[17,27],'Tunisia':[9,34],
    'Algeria':[3,28],'Morocco':[-7,32],'Nigeria':[8,10],'Ghana':[-1,8],
    'Kenya':[38,-1],'Ethiopia':[40,8],'South Africa':[25,-29],'Tanzania':[35,-6],
    'Germany':[10,51],'France':[2,46],'United Kingdom':[-3,54],'Great Britain':[-3,54],
    'Italy':[12,42],'Spain':[-4,40],'Netherlands':[5.3,52.1],'Belgium':[4.5,50.5],
    'Portugal':[-8,39],'Sweden':[18,63],'Norway':[15,65],'Denmark':[10,56],
    'Finland':[26,64],'Poland':[20,52],'Austria':[14,47],'Switzerland':[8,47],
    'Greece':[22,39],'Romania':[25,46],'Hungary':[19,47],'Czech Republic':[16,50],
    'Ukraine':[32,49],'Bulgaria':[25,43],'Croatia':[16,45],'Russia':[55,60],
    'China':[104,35],'Japan':[138,36],'India':[78,20],'Pakistan':[69,30],
    'Malaysia':[110,4],'Singapore':[104,1.3],'Indonesia':[118,-2],
    'Philippines':[122,13],'South Korea':[128,36],'Taiwan':[121,24],
    'Thailand':[101,15],'Vietnam':[108,16],'United States':[-98,38],
    'Canada':[-96,60],'Mexico':[-102,24],'Brazil':[-53,-10],'Argentina':[-64,-34],
    'Australia':[134,-25],'New Zealand':[172,-41],'Iran':[53,32],
  };

  /* ─── Carrier info ─── */
  /* Self-hosted carrier marks (Simple Icons, white). Clearbit's logo API is dead.
     Carriers without an icon fall back to a clean text label (logo:''). */
  var CARRIERS={
    ups:   {name:'UPS',          logo:(LOGOS.ups||'')},
    usps:  {name:'USPS',         logo:(LOGOS.usps||'')},
    dhl:   {name:'DHL Express',  logo:(LOGOS.dhl||'')},
    fedex: {name:'FedEx',        logo:(LOGOS.fedex||'')},
    dpd:   {name:'DPD',          logo:(LOGOS.dpd||'')},
    aramex:{name:'Aramex',       logo:''},
    tnt:   {name:'TNT',          logo:''},
    gls:   {name:'GLS',          logo:''},
    rtd:   {name:'RTD Express',  logo:''},
  };

  /* Client-side hint only — the worker (17TRACK) does the real auto-detection and returns the
     true carrier. So we ONLY assert here for high-confidence formats and never guess from a bare
     digit-count (that caused false "USPS"/etc. labels). Everything else → neutral. */
  function detectCarrier(n){
    n=n.replace(/\s+/g,'').toUpperCase();
    if(/^1Z[A-Z0-9]{16}$/.test(n))return 'ups';
    if(/^(JD|GM)\d{16,}$/.test(n))return 'dhl';
    if(/^(94|93|92|95|70|77|82)\d{14,}$/.test(n))return 'usps';
    // S10 universal postal format AA#########CC — the last 2 letters are the ORIGIN country, NOT a
    // carrier. Only hint when we actually carry that country's postal/courier mark; else stay neutral.
    var m=n.match(/^[A-Z]{2}\d{9}([A-Z]{2})$/);
    if(m){ if(m[1]==='US')return 'usps'; if(m[1]==='DE')return 'dhl'; return null; }
    return null;
  }

  /* ─── Draw helpers ─── */
  /* Limb crossing between a visible point and a hidden one, snapped onto the rim circle */
  function _limbCross(vis, hid) {
    var t = vis.z / (vis.z - hid.z);
    var x = vis.x + (hid.x - vis.x) * t, y = vis.y + (hid.y - vis.y) * t;
    var dx = x - SZ/2, dy = y - SZ/2, len = Math.sqrt(dx*dx + dy*dy) || 1, s = displayR / len;
    return { x: SZ/2 + dx*s, y: SZ/2 + dy*s };
  }
  function _rimAng(x,y){ return Math.atan2(y-SZ/2, x-SZ/2); }
  function _ccw(a1,a2){ var d=a2-a1; while(d<0)d+=Math.PI*2; while(d>=Math.PI*2)d-=Math.PI*2; return d; }
  function drawPoly(poly, fill, stroke, lw) {
    var n = poly.length, P = new Array(n);
    for (var i=0;i<n;i++) P[i] = proj(poly[i][0], poly[i][1]);
    /* FILL: one closed contour. When the ring crosses the horizon we walk along the
       RIM ARC between the exit and entry crossings (in the direction the hidden part
       of the ring sits) — a straight chord there sliced giant phantom wedges across
       the sphere at some rotations, especially when zoomed + dragging. */
    if (fill) {
      /* Rotate the loop to start on a visible vertex so the wrap-around closes cleanly */
      var s=-1;
      for (var i=0;i<n;i++) if (P[i].v) { s=i; break; }
      if (s !== -1) {
        ctx.beginPath();
        var started=false, exitAng=null, hidSX=0, hidSY=0, hidN=0;
        for (var k=0;k<n;k++) {
          var i2=(s+k)%n;
          var a=P[i2], b=P[(i2+1)%n];
          if (a.v) {
            if (!started) { ctx.moveTo(a.x,a.y); started=true; } else ctx.lineTo(a.x,a.y);
            if (!b.v) {                                   /* leaving view */
              var c=_limbCross(a,b); ctx.lineTo(c.x,c.y);
              exitAng=_rimAng(c.x,c.y); hidSX=0; hidSY=0; hidN=0;
            }
          } else {
            /* Track WHERE the hidden run sits as a mean of unit direction vectors —
               positions bias toward the centre for deep-behind points and gave a
               garbage angle (→ wrong-way arcs → giant phantom wedges). */
            var hdx=a.x-SZ/2, hdy=a.y-SZ/2, hdl=Math.sqrt(hdx*hdx+hdy*hdy)||1;
            hidSX+=hdx/hdl; hidSY+=hdy/hdl; hidN++;
            if (b.v) {                                    /* entering view */
              var c2=_limbCross(b,a);
              if (exitAng!==null) {
                var entAng=_rimAng(c2.x,c2.y);
                var acw;
                var hmag=Math.sqrt(hidSX*hidSX+hidSY*hidSY);
                if (!hidN || hmag < 0.35*hidN && hmag < 2) {
                  /* Direction ambiguous (hidden run wraps wide) → take the SHORT arc,
                     which can never fill a band across the visible face. */
                  acw = _ccw(exitAng,entAng) > Math.PI;
                } else {
                  var hAng=Math.atan2(hidSY,hidSX);
                  acw = _ccw(exitAng,hAng) <= _ccw(exitAng,entAng) ? false : true;
                }
                ctx.arc(SZ/2,SZ/2,displayR,exitAng,entAng,acw);
                exitAng=null;
              } else {
                ctx.lineTo(c2.x,c2.y);
              }
            }
          }
        }
        if (started) { ctx.closePath(); ctx.fillStyle=fill; ctx.fill(); }
      }
    }
    /* STROKE: visible coastline only (no rim arcs drawn) */
    if (stroke) {
      ctx.beginPath();
      var m=false, pv=false;
      for (var i=0;i<n;i++) {
        var p=P[i];
        if (p.v) { if(!m||!pv){ctx.moveTo(p.x,p.y);m=true;} else ctx.lineTo(p.x,p.y); }
        pv=p.v;
      }
      ctx.strokeStyle=stroke; ctx.lineWidth=lw||1; ctx.stroke();
    }
  }

  function drawArcPath(pts, count, color, lw, dash) {
    ctx.beginPath();var m=false;
    for(var i=0;i<=count&&i<pts.length;i++){
      var p=proj(pts[i].lon,pts[i].lat);
      if(!p.v){m=false;continue;}
      if(!m){ctx.moveTo(p.x,p.y);m=true;}else{ctx.lineTo(p.x,p.y);}
    }
    ctx.setLineDash(dash||[]);
    ctx.strokeStyle=color;ctx.lineWidth=lw;ctx.stroke();
    ctx.setLineDash([]);
  }

  /* ─── Main draw ─── */
  function drawGlobe() {
    /* Tween display radius (zoom) */
    displayR += (targetR - displayR) * 0.06;

    ctx.clearRect(0,0,SZ,SZ);


    /* (Atmosphere halo removed — the glow now comes from a static CSS box-shadow on the canvas, so it
       no longer shimmers/jumps during drag & zoom. The sphere also fills the canvas now, so there's no
       gap ring revealing a gold gradient.) */

    /* Ocean */
    var ocean=ctx.createRadialGradient(SZ/2-displayR*0.28,SZ/2-displayR*0.3,0,SZ/2,SZ/2,displayR);
    ocean.addColorStop(0,'#1c1c1c');ocean.addColorStop(0.45,'#0e0e0e');ocean.addColorStop(0.85,'#050505');ocean.addColorStop(1,'#000');
    ctx.beginPath();ctx.arc(SZ/2,SZ/2,displayR,0,Math.PI*2);ctx.fillStyle=ocean;ctx.fill();

    /* Clip to sphere */
    ctx.save();
    ctx.beginPath();ctx.arc(SZ/2,SZ/2,displayR,0,Math.PI*2);ctx.clip();

    /* Grid — finer sampling when zoomed in so the curves stay smooth, not angular */
    var gs = displayR > R*2.2 ? 1 : 3;
    ctx.strokeStyle='rgba(255,255,255,0.04)';ctx.lineWidth=0.5;
    for(var gla=-60;gla<=60;gla+=30){
      ctx.beginPath();var gm=false;
      for(var glo=-180;glo<=180;glo+=gs){var gp=proj(glo,gla);if(!gp.v){gm=false;continue;}if(!gm){ctx.moveTo(gp.x,gp.y);gm=true;}else ctx.lineTo(gp.x,gp.y);}
      ctx.stroke();
    }
    for(var glo2=-180;glo2<180;glo2+=30){
      ctx.beginPath();var gm2=false;
      for(var gla2=-86;gla2<=86;gla2+=gs){var gp2=proj(glo2,gla2);if(!gp2.v){gm2=false;continue;}if(!gm2){ctx.moveTo(gp2.x,gp2.y);gm2=true;}else ctx.lineTo(gp2.x,gp2.y);}
      ctx.stroke();
    }

    /* Land fill — clean bronze continents (no per-poly shadow → keeps the detailed borders fast). */
    /* Fill from the cell-split geometry (wedge-proof); strokes below use the
       original rings so the coastlines render exactly as before. */
    LAND_FILL.forEach(function(poly){ drawPoly(poly,'#333',null,0); });
    ICE_FILL.forEach(function(poly){ drawPoly(poly,'rgba(90,90,90,0.55)',null,0); });
    /* Accurate country borders — quieter internal divisions so coastlines lead. */
    COUNTRIES.forEach(function(poly){ drawPoly(poly,null,'rgba(255,255,255,0.14)',0.5); });
    /* Bright coastline accent over the borders for crisp continent edges. */
    LANDS.forEach(function(poly){ drawPoly(poly,null,'rgba(255,255,255,0.5)',0.8); });

    /* Desert overlays — sandy brown tint on top of land */
    DESERTS.forEach(function(poly){
      drawPoly(poly,'rgba(0,0,0,0)',null,0);
    });

    /* Rivers — thin blue lines */
    ctx.save();
    RIVERS.forEach(drawRiver);
    ctx.restore();

    /* Ghost arc */
    if(ARC.length) drawArcPath(ARC,ARC.length-1,'rgba(255,255,255,0.38)',2.2,[6,4]);

    /* Progress arc — glowing trail (only during the flight legs; local delivery de-emphasizes it) */
    if(ARC.length&&planeProgress>0.01&&currentStage<4){
      var pidx=Math.round(Math.min(planeProgress,1)*(ARC.length-1));
      ctx.save();
      ctx.shadowColor='rgba(255,255,255,0.7)';ctx.shadowBlur=12;
      drawArcPath(ARC,pidx,'rgba(255,255,255,0.96)',3,[]);
      ctx.restore();
    }

    /* Network connections */
    CONNS.forEach(function(c,ci){
      var a=CITIES[c[0]],b=CITIES[c[1]];
      var pa=proj(a.lon,a.lat),pb=proj(b.lon,b.lat);
      if(!pa.v||!pb.v)return;
      var pulse=(Math.sin(frame*0.04+ci*0.9)+1)/2;
      ctx.beginPath();ctx.moveTo(pa.x,pa.y);ctx.lineTo(pb.x,pb.y);
      ctx.strokeStyle='rgba(255,255,255,'+(0.03+pulse*0.07)+')';ctx.lineWidth=0.7;ctx.stroke();
    });

    /* Country-name labels (curated 'major' always; all when zoomed in; off-canvas ones culled) */
    if(!COUNTRY_LABELS||!COUNTRY_LABELS.length) buildCountryLabels();
    var _showAll = displayR > R*1.7;
    ctx.save();
    ctx.textAlign='center';
    try{ctx.letterSpacing='0.8px';}catch(e){}
    /* Labels grow gently with zoom so they don't vanish against huge landmasses */
    var _lfs=(6.8*Math.min(2.2,Math.pow(displayR/R,0.4))).toFixed(1);
    ctx.font='700 '+_lfs+'px -apple-system,Segoe UI,sans-serif';
    ctx.shadowColor='rgba(0,0,0,0.8)';ctx.shadowBlur=3;
    COUNTRY_LABELS.forEach(function(c){
      if(!_showAll && !c.major) return;
      var p=proj(c.lon,c.lat); if(!p.v) return;
      if(p.x<8||p.x>SZ-8||p.y<12||p.y>SZ-6) return;
      /* Fade labels toward the horizon so the sphere edge stays clean */
      var depth=Math.max(0,Math.min(1,p.z*1.7));
      var a=(c.major?0.5:0.34)*depth;
      if(a<0.05) return;
      ctx.fillStyle='rgba(255,255,255,'+a.toFixed(3)+')';
      ctx.fillText(c.name.toUpperCase(),p.x,p.y);
    });
    try{ctx.letterSpacing='0px';}catch(e){}
    ctx.shadowBlur=0;ctx.textAlign='left';
    ctx.restore();

    /* City nodes */
    CITIES.forEach(function(city,i){
      var p=proj(city.lon,city.lat);
      if(!p.v)return;
      var pulse=(Math.sin(frame*0.06+i*1.2)+1)/2;
      if(city.origin||city.dest){
        ctx.beginPath();ctx.arc(p.x,p.y,5+pulse*16,0,Math.PI*2);
        ctx.strokeStyle='rgba(255,255,255,'+(0.38*(1-pulse))+')';ctx.lineWidth=1;ctx.stroke();
        var gd=ctx.createRadialGradient(p.x,p.y,0,p.x,p.y,9);
        gd.addColorStop(0,'rgba(255,255,255,0.95)');gd.addColorStop(1,'rgba(255,255,255,0)');
        ctx.beginPath();ctx.arc(p.x,p.y,9,0,Math.PI*2);ctx.fillStyle=gd;ctx.fill();
        ctx.beginPath();ctx.arc(p.x,p.y,4.5,0,Math.PI*2);ctx.fillStyle='#fff';ctx.fill();
        ctx.fillStyle='rgba(255,255,255,0.82)';ctx.font='bold 8px -apple-system,sans-serif';
        ctx.fillText(city.origin?'JERZIFY HQ':city.n.toUpperCase(),p.x+10,p.y-5);
      }else{
        var r=2+pulse*1.5;
        ctx.beginPath();ctx.arc(p.x,p.y,r,0,Math.PI*2);
        ctx.fillStyle='rgba(255,255,255,'+(0.22+pulse*0.28)+')';ctx.fill();
        ctx.beginPath();ctx.arc(p.x,p.y,r+2+pulse*4,0,Math.PI*2);
        ctx.strokeStyle='rgba(255,255,255,'+(0.08*(1-pulse))+')';ctx.lineWidth=0.6;ctx.stroke();
      }
    });

    /* Jerzify hubs — Main HQ (Lebanon) + China hub, both labeled. */
    HQS.forEach(function(hq){
      var p=proj(hq.lon,hq.lat); if(!p.v) return;
      var pulse=(Math.sin(frame*0.06)+1)/2;
      ctx.beginPath();ctx.arc(p.x,p.y,6+pulse*14,0,Math.PI*2);
      ctx.strokeStyle='rgba(255,255,255,'+(0.4*(1-pulse))+')';ctx.lineWidth=1.2;ctx.stroke();
      var hg=ctx.createRadialGradient(p.x,p.y,0,p.x,p.y,11);
      hg.addColorStop(0,'rgba(255,255,255,0.95)');hg.addColorStop(1,'rgba(255,255,255,0)');
      ctx.beginPath();ctx.arc(p.x,p.y,11,0,Math.PI*2);ctx.fillStyle=hg;ctx.fill();
      ctx.save();ctx.shadowColor='rgba(255,255,255,0.9)';ctx.shadowBlur=8;
      ctx.beginPath();ctx.arc(p.x,p.y,hq.main?5.5:4.5,0,Math.PI*2);ctx.fillStyle='#fff';ctx.fill();
      ctx.shadowBlur=0;ctx.restore();
      /* label — premium pill card beside the marker (matches the destination card) */
      ctx.textAlign='left';
      ctx.font='bold 8px -apple-system,sans-serif';
      var _w1=ctx.measureText(hq.name).width;
      ctx.font='600 6.5px -apple-system,sans-serif';
      var _w2=ctx.measureText(hq.sub).width;
      var _pw=Math.max(_w1,_w2)+16, _ph=24, _px=p.x+13, _py=Math.round(p.y-_ph/2);
      ctx.save();ctx.shadowColor='rgba(0,0,0,0.6)';ctx.shadowBlur=6;
      trkRoundRect(_px,_py,_pw,_ph,0);ctx.fillStyle='#fff';ctx.fill();ctx.shadowBlur=0;
      ctx.restore();
      ctx.font='bold 8px -apple-system,sans-serif';ctx.fillStyle='#000';ctx.fillText(hq.name,_px+8,_py+10);
      ctx.font='600 6.5px -apple-system,sans-serif';ctx.fillStyle='rgba(0,0,0,0.6)';ctx.fillText(hq.sub,_px+8,_py+19);
    });

    /* Destination marker — a prominent "your order is HERE" pin with a label card. */
    if(DEST){
      var pd=proj(DEST.lon,DEST.lat);
      if(pd.v){
        var dp=(frame%110)/110;
        /* radar pulse ring */
        ctx.beginPath();ctx.arc(pd.x,pd.y,7+dp*28,0,Math.PI*2);
        ctx.strokeStyle='rgba(255,255,255,'+(0.55*(1-dp))+')';ctx.lineWidth=1.5;ctx.stroke();
        /* glow halo */
        var dg=ctx.createRadialGradient(pd.x,pd.y,0,pd.x,pd.y,20);
        dg.addColorStop(0,'rgba(255,255,255,0.55)');dg.addColorStop(1,'rgba(255,255,255,0)');
        ctx.beginPath();ctx.arc(pd.x,pd.y,20,0,Math.PI*2);ctx.fillStyle=dg;ctx.fill();
        /* bullseye dot */
        ctx.save();ctx.shadowColor='rgba(255,255,255,0.9)';ctx.shadowBlur=10;
        ctx.beginPath();ctx.arc(pd.x,pd.y,6.5,0,Math.PI*2);ctx.fillStyle='#fff';ctx.fill();ctx.shadowBlur=0;
        ctx.beginPath();ctx.arc(pd.x,pd.y,2.6,0,Math.PI*2);ctx.fillStyle='#000';ctx.fill();
        ctx.restore();
        /* label card above the pin: country · status */
        var stat=currentStage>=5?'DELIVERED':currentStage>=4?'OUT FOR DELIVERY':currentStage>=3?'ARRIVED':'DESTINATION';
        var line=(DEST.label||'DESTINATION')+'  ·  '+stat;
        ctx.font='bold 8.5px -apple-system,sans-serif';
        var tw=ctx.measureText(line).width, padX=9, eW=0;
        var pw=tw+padX*2+eW, ph=18, px=Math.round(pd.x-pw/2), py=Math.round(pd.y-18-ph);
        /* connector */
        ctx.beginPath();ctx.moveTo(pd.x,py+ph);ctx.lineTo(pd.x,pd.y-7);ctx.strokeStyle='rgba(255,255,255,0.4)';ctx.lineWidth=1;ctx.stroke();
        ctx.save();ctx.shadowColor='rgba(0,0,0,0.55)';ctx.shadowBlur=7;
        trkRoundRect(px,py,pw,ph,0);ctx.fillStyle='#fff';ctx.fill();ctx.shadowBlur=0;
        ctx.restore();
        ctx.textAlign='left';
        ctx.font='bold 8.5px -apple-system,sans-serif';ctx.fillStyle='#000';ctx.fillText(line,px+padX+eW,py+ph/2+3);
      }
    }

    /* Plane — only while in transit (hidden once arrived/delivered so it doesn't cover the marker) */
    planeVisible=false;
    if(ARC.length&&planeProgress>0.01&&currentStage<3){
      var pidx2=Math.round(Math.min(planeProgress,1)*(ARC.length-1));
      var pp=proj(ARC[pidx2].lon,ARC[pidx2].lat);
      if(pp.v){
        planeVisible=true;
        planePx=pp.x; planePy=pp.y;
        var ah=Math.min(pidx2+2,ARC.length-1);
        var pa2=proj(ARC[ah].lon,ARC[ah].lat);
        var ang=Math.atan2(pa2.y-pp.y,pa2.x-pp.x);
        var gw=ctx.createRadialGradient(pp.x,pp.y,0,pp.x,pp.y,22);
        gw.addColorStop(0,'rgba(255,255,255,0.38)');gw.addColorStop(1,'rgba(255,255,255,0)');
        ctx.beginPath();ctx.arc(pp.x,pp.y,22,0,Math.PI*2);ctx.fillStyle=gw;ctx.fill();
        var fp=(Math.sin(frame*0.14)+1)/2;
        ctx.beginPath();ctx.arc(pp.x,pp.y,9+fp*13,0,Math.PI*2);
        ctx.strokeStyle='rgba(255,255,255,'+(0.52*(1-fp))+')';ctx.lineWidth=1.2;ctx.stroke();
        ctx.save();ctx.translate(pp.x,pp.y);ctx.rotate(ang);
        ctx.shadowColor='rgba(255,255,255,0.9)';ctx.shadowBlur=12;
        /* swept wings */
        ctx.fillStyle='#bdbdbd';
        ctx.beginPath();ctx.moveTo(-1,0);ctx.lineTo(-10,-11);ctx.lineTo(-4,-11);ctx.lineTo(4,-1);ctx.closePath();ctx.fill();
        ctx.beginPath();ctx.moveTo(-1,0);ctx.lineTo(-10,11);ctx.lineTo(-4,11);ctx.lineTo(4,1);ctx.closePath();ctx.fill();
        /* tailplane */
        ctx.beginPath();ctx.moveTo(-10,0);ctx.lineTo(-15,-4.5);ctx.lineTo(-11,-0.6);ctx.lineTo(-11,0.6);ctx.lineTo(-15,4.5);ctx.closePath();ctx.fill();
        /* bright fuselage */
        ctx.fillStyle='#fff';
        ctx.beginPath();ctx.moveTo(16,0);ctx.quadraticCurveTo(6,3,-11,2.3);ctx.lineTo(-11,-2.3);ctx.quadraticCurveTo(6,-3,16,0);ctx.closePath();ctx.fill();
        ctx.shadowBlur=0;ctx.restore();
        /* Tap badge — gold pill */
        ctx.save();
        ctx.shadowColor='rgba(255,255,255,0.5)';ctx.shadowBlur=6;
        var bw=38,bh=14,bx=pp.x-bw/2,by=pp.y-38;
        trkRoundRect(bx,by,bw,bh,0);ctx.fillStyle='#fff';ctx.fill();
        ctx.shadowBlur=0;
        ctx.fillStyle='#000';ctx.font='bold 7.5px -apple-system,sans-serif';ctx.textAlign='center';
        ctx.fillText('TAP',pp.x,by+9.5);ctx.textAlign='left';
        ctx.restore();
      }
    }

    ctx.restore(); /* unclip */

    /* Sphere shading — rim vignette only, and it FADES OUT with zoom. The gradient
       scales with the sphere, so when zoomed in its dark outer ring used to sweep
       across the canvas as a huge curved band ("something wrong when scrolling").
       Zoomed in = looking at the surface = no rim shading at all. */
    var vig=Math.max(0,Math.min(1,1-(displayR/R-1)*1.15));
    if(vig>0.02){
      var sh=ctx.createRadialGradient(SZ/2-displayR*0.35,SZ/2-displayR*0.4,0,SZ/2,SZ/2,displayR);
      sh.addColorStop(0,'rgba(255,255,255,'+(0.045*vig).toFixed(3)+')');
      sh.addColorStop(0.55,'rgba(0,0,0,0)');
      sh.addColorStop(0.88,'rgba(0,0,0,'+(0.28*vig).toFixed(3)+')');
      sh.addColorStop(1,'rgba(0,0,0,'+(0.6*vig).toFixed(3)+')');
      ctx.beginPath();ctx.arc(SZ/2,SZ/2,displayR,0,Math.PI*2);ctx.fillStyle=sh;ctx.fill();
      /* Double rim: crisp gold hairline + soft inner echo */
      ctx.beginPath();ctx.arc(SZ/2,SZ/2,displayR-0.6,0,Math.PI*2);
      ctx.strokeStyle='rgba(255,255,255,'+(0.32*vig).toFixed(3)+')';ctx.lineWidth=1.2;ctx.stroke();
      ctx.beginPath();ctx.arc(SZ/2,SZ/2,displayR-3.5,0,Math.PI*2);
      ctx.strokeStyle='rgba(255,255,255,'+(0.07*vig).toFixed(3)+')';ctx.lineWidth=2.2;ctx.stroke();
    }

    frame++;

    /* Rotation — ease to the locked target and STOP (no idle spin; the user can drag to explore). */
    if(!dragging&&!userMoved&&lockedY!==null){
      var dY=lockedY-rotY, dX=lockedX-rotX;
      rotY+=dY*0.07; rotX+=dX*0.07;
    }

    /* Ease plane progress */
    if(Math.abs(planeProgress-targetProgress)>0.0005)
      planeProgress+=(targetProgress-planeProgress)*0.018;

    /* Globe continuously tracks the plane position along the arc (unless the user took over) */
    if(currentStage===2&&ARC.length&&!dragging&&!userMoved){
      var tpidx=Math.round(Math.min(Math.max(planeProgress,0.01),0.99)*(ARC.length-1));
      lockedY=ARC[tpidx].lon*Math.PI/180;
      lockedX=ARC[tpidx].lat*Math.PI/180;
    }
  }

  /* ═══════════════════════════════════════
     LEBANON SCENE — last-mile map
     Shown instead of the globe once a Lebanese order has landed (stage ≥ 3).
     Real route: Jerzify HQ (Saida) → RTD Express hub (Beirut, Cola) → the customer's city.
     City-level only: the worker exposes shipping_city, never the street address, and RTD
     gives scan events, not courier GPS — so the courier marker is placed from the courier
     STAGE along that route. It is not a live location; the on-page hint says so.
  ═══════════════════════════════════════ */
  var LBMAP = window.JZ_LB_MAP || null;
  var scene = 'globe', lbAvail = false;
  var lbDest = null, lbRegion = -1, lbU = 0, lbUTarget = 0, lbStage = 0, lbStatus = 'DESTINATION';
  var lbBase = null, lbBaseKey = '';
  var LB_HQ  = { lon: 35.372, lat: 33.560 };   /* Jerzify HQ — Saida */
  var LB_HUB = { lon: 35.496, lat: 33.875 };   /* RTD Express hub — Beirut, Cola */
  var LB_C = { lon: 35.852, lat: 33.872 }, LB_K = 285, LB_COS = Math.cos(33.872 * Math.PI / 180);
  function lbXY(lon, lat){ return { x: SZ/2 + (lon - LB_C.lon) * LB_COS * LB_K, y: SZ/2 - (lat - LB_C.lat) * LB_K }; }

  /* Gazetteer [lon,lat], ±2–3 km — plenty for a country-scale map. Keys are normalised (see lbNorm). */
  var LB_CITIES = {
    beirut:[35.50,33.89],beyrouth:[35.50,33.89],bayrut:[35.50,33.89],'بيروت':[35.50,33.89],
    achrafieh:[35.52,33.89],ashrafieh:[35.52,33.89],hamra:[35.48,33.90],verdun:[35.48,33.88],raouche:[35.47,33.89],
    rasbeirut:[35.48,33.90],mazraa:[35.50,33.88],badaro:[35.52,33.88],gemmayzeh:[35.52,33.90],marmikhael:[35.53,33.90],
    bourjhammoud:[35.54,33.89],burjhammoud:[35.54,33.89],sinelfil:[35.54,33.87],dekwaneh:[35.55,33.88],jdeideh:[35.57,33.89],
    zalka:[35.57,33.90],jaleldib:[35.58,33.91],antelias:[35.59,33.91],naccache:[35.59,33.92],dbayeh:[35.59,33.93],
    mansourieh:[35.57,33.86],hazmieh:[35.54,33.85],baabda:[35.54,33.83],hadath:[35.53,33.84],furnelchebbak:[35.53,33.87],
    chiyah:[35.52,33.86],ghobeiry:[35.51,33.86],harethreik:[35.51,33.85],dahieh:[35.51,33.85],dahiyeh:[35.51,33.85],
    bourjelbarajneh:[35.50,33.85],kfarshima:[35.53,33.81],choueifat:[35.51,33.81],khalde:[35.48,33.78],aramoun:[35.50,33.76],
    bchamoun:[35.52,33.78],naameh:[35.46,33.74],damour:[35.45,33.73],beitmery:[35.60,33.86],broummana:[35.62,33.88],
    brummana:[35.62,33.88],baabdat:[35.67,33.89],bikfaya:[35.68,33.92],dhourchoueir:[35.71,33.91],
    jounieh:[35.62,33.98],jounie:[35.62,33.98],'جونية':[35.62,33.98],'جونيه':[35.62,33.98],kaslik:[35.62,33.98],zoukmosbeh:[35.61,33.95],
    zoukmikael:[35.62,33.97],adma:[35.64,34.00],ghazir:[35.66,34.02],ajaltoun:[35.69,33.96],rayfoun:[35.70,33.97],faraya:[35.82,34.01],
    jbeil:[35.65,34.12],byblos:[35.65,34.12],'جبيل':[35.65,34.12],amchit:[35.64,34.15],batroun:[35.66,34.26],'البترون':[35.66,34.26],
    chekka:[35.73,34.32],anfeh:[35.73,34.35],amioun:[35.80,34.30],koura:[35.80,34.30],kousba:[35.85,34.30],douma:[35.84,34.20],
    tannourine:[35.93,34.21],bcharre:[36.01,34.25],bsharri:[36.01,34.25],ehden:[35.99,34.29],zgharta:[35.89,34.40],'زغرتا':[35.89,34.40],
    tripoli:[35.84,34.44],trablos:[35.84,34.44],tarablus:[35.84,34.44],'طرابلس':[35.84,34.44],mina:[35.81,34.45],elmina:[35.81,34.45],
    minieh:[35.94,34.48],halba:[36.08,34.54],'حلبا':[36.08,34.54],akkar:[36.08,34.54],'عكار':[36.08,34.54],qobayat:[36.28,34.57],kobayat:[36.28,34.57],
    aley:[35.60,33.81],'عاليه':[35.60,33.81],bhamdoun:[35.65,33.81],sofar:[35.70,33.80],deirelqamar:[35.56,33.70],beiteddine:[35.58,33.69],
    baakline:[35.56,33.68],barja:[35.44,33.65],chhim:[35.49,33.62],jiyeh:[35.40,33.66],
    saida:[35.37,33.56],sidon:[35.37,33.56],sayda:[35.37,33.56],'صيدا':[35.37,33.56],ghazieh:[35.37,33.52],sarafand:[35.30,33.45],
    jezzine:[35.58,33.54],'جزين':[35.58,33.54],tyre:[35.20,33.27],sour:[35.20,33.27],tyr:[35.20,33.27],'صور':[35.20,33.27],qana:[35.30,33.21],
    nabatieh:[35.48,33.38],nabatiyeh:[35.48,33.38],nabatiye:[35.48,33.38],'النبطية':[35.48,33.38],bintjbeil:[35.43,33.12],'بنت جبيل':[35.43,33.12],
    tebnine:[35.41,33.19],marjayoun:[35.59,33.36],marjeyoun:[35.59,33.36],khiam:[35.61,33.33],hasbaya:[35.68,33.40],
    zahle:[35.90,33.85],zahleh:[35.90,33.85],'زحلة':[35.90,33.85],'زحله':[35.90,33.85],chtaura:[35.85,33.82],chtoura:[35.85,33.82],
    saadnayel:[35.88,33.81],taalabaya:[35.87,33.82],qabelias:[35.82,33.80],barelias:[35.90,33.77],anjar:[35.93,33.73],majdalanjar:[35.90,33.71],
    riyaq:[36.00,33.85],rayak:[36.00,33.85],joubjannine:[35.78,33.63],machghara:[35.65,33.53],rachaya:[35.84,33.50],
    baalbek:[36.21,34.00],baalbeck:[36.21,34.00],'بعلبك':[36.21,34.00],labweh:[36.35,34.20],arsal:[36.42,34.18],rasbaalbek:[36.42,34.26],
    hermel:[36.39,34.39],'الهرمل':[36.39,34.39],qaa:[36.47,34.34]
  };
  function lbNorm(s){
    s = String(s || '').toLowerCase();
    try { s = s.normalize('NFD').replace(/[̀-ͯ]/g, ''); } catch (e) {}
    return s.replace(/\b(el|al|ed|ech|er|ez)[\s-]+/g, 'el').replace(/[^a-z0-9؀-ۿ]/g, '');
  }
  function lbLookup(city){
    var raw = String(city || '').trim(); if (!raw) return null;
    if (LB_CITIES[raw]) return LB_CITIES[raw];                       /* Arabic keys keep their spaces */
    var n = lbNorm(raw); if (!n) return null;
    if (LB_CITIES[n]) return LB_CITIES[n];
    var n2 = n.replace(/^el/, ''); if (LB_CITIES[n2]) return LB_CITIES[n2];
    /* "Beirut - Achrafieh", "Jounieh Kaslik": take the LONGEST known place the text contains */
    var best = null, bl = 4;
    for (var k in LB_CITIES) { var kn = lbNorm(k); if (kn.length > bl && n.indexOf(kn) > -1) { best = LB_CITIES[k]; bl = kn.length; } }
    return best;
  }
  function lbRegionAt(lon, lat){
    if (!LBMAP) return -1;
    for (var r = 0; r < LBMAP.regions.length; r++) {
      var g = LBMAP.regions[r].ring, inside = false;
      for (var i = 0, j = g.length - 2; i < g.length; j = i, i += 2) {
        var xi = g[i], yi = g[i+1], xj = g[j], yj = g[j+1];
        if ((yi > lat) !== (yj > lat) && lon < (xj - xi) * (lat - yi) / ((yj - yi) || 1e-9) + xi) inside = !inside;
      }
      if (inside) return r;
    }
    return -1;
  }
  /* Courier stage → position on the two-leg route. u∈[0,1] = HQ (Saida) → RTD hub (Beirut, Cola); u∈[1,2] = hub → customer's city.
     Mirrors renderRtd(): with no scans yet, the stage falls back to the order's main stage. */
  function lbProgressFor(data, stage){
    var evs = (data && data.rtd && Array.isArray(data.rtd.events)) ? data.rtd.events : [], s = 0;
    evs.forEach(function(e){ var i = rtdStageInfo(e && (e.status || e.desc)); if (i.stage > s) s = i.stage; });
    if (!evs.length) s = stage >= 5 ? 4 : stage >= 4 ? 3 : stage >= 3 ? 1 : 0;
    if (stage >= 5) s = 4;
    lbStage = s;
    return [0, 0.55, 1, 1.6, 2][s];
  }

  /* Static chart layer — coast ripples, graticule, regions, towns, scale bar. Transparent background: the
     dotted backdrop is CSS on the console, so the map and the panel around it share one texture.
     Rendered once per size / region / destination and blitted every frame. */
  var LB_TOWNS = [['TRIPOLI',35.84,34.44,-1],['JBEIL',35.65,34.12,-1],['TYRE',35.20,33.27,-1],['JOUNIEH',35.62,33.98,-1],
                  ['ZAHLE',35.90,33.85,1],['BAALBEK',36.21,34.00,1],['HERMEL',36.39,34.39,1],['HALBA',36.08,34.54,1],['NABATIEH',35.48,33.38,1]];
  function lbBuildBase(){
    var c = document.createElement('canvas'); c.width = SZ * KPX; c.height = SZ * KPX;
    var g = c.getContext('2d'); g.scale(KPX, KPX);
    var FONT = '-apple-system,Segoe UI,sans-serif';
    function path(r){ g.beginPath(); for (var i = 0; i < r.length; i += 2) { var p = lbXY(r[i], r[i+1]); if (i) g.lineTo(p.x, p.y); else g.moveTo(p.x, p.y); } g.closePath(); }
    /* graticule + degree labels on the frame */
    g.setLineDash([2, 5]); g.strokeStyle = 'rgba(255,255,255,0.10)'; g.lineWidth = 0.7;
    g.font = '600 6.5px ' + FONT; g.fillStyle = 'rgba(255,255,255,0.34)'; try { g.letterSpacing = '0.8px'; } catch (e) {}
    [35.5, 36.0, 36.5].forEach(function(lo){ var p = lbXY(lo, 0); g.beginPath(); g.moveTo(p.x, 14); g.lineTo(p.x, SZ - 6); g.stroke(); g.textAlign = 'center'; g.fillText(lo.toFixed(1) + '°E', p.x, 9); });
    [33.5, 34.0, 34.5].forEach(function(la){ var p = lbXY(0, la); g.beginPath(); g.moveTo(34, p.y); g.lineTo(SZ - 6, p.y); g.stroke(); g.textAlign = 'left'; g.fillText(la.toFixed(1) + '°N', 4, p.y + 2.4); });
    g.setLineDash([]);
    /* coast ripples: wide faint strokes whose inner half is covered by the land */
    g.lineJoin = 'round';
    [[26, 0.035], [17, 0.05], [9, 0.07]].forEach(function(w){ g.strokeStyle = 'rgba(255,255,255,' + w[1] + ')'; g.lineWidth = w[0]; LBMAP.regions.forEach(function(R){ path(R.ring); g.stroke(); }); });
    /* land */
    g.save(); g.shadowColor = 'rgba(255,255,255,0.22)'; g.shadowBlur = 22 * KPX;
    LBMAP.regions.forEach(function(R){ path(R.ring); g.fillStyle = '#1b1b1b'; g.fill(); });
    g.restore();
    var land = g.createLinearGradient(lbXY(35.1, 0).x, 0, lbXY(36.6, 0).x, 0); land.addColorStop(0, '#2b2b2b'); land.addColorStop(1, '#161616');
    LBMAP.regions.forEach(function(R, i){
      path(R.ring); g.fillStyle = i === lbRegion ? '#4a4a4a' : land; g.fill();
      g.strokeStyle = 'rgba(255,255,255,0.34)'; g.lineWidth = 0.8; g.stroke();
    });
    /* sea / neighbour names */
    g.textAlign = 'center'; try { g.letterSpacing = '2.4px'; } catch (e) {}
    g.font = '700 7px ' + FONT; g.fillStyle = 'rgba(255,255,255,0.30)';
    g.fillText('MEDITERRANEAN', 96, 132); g.fillText('SEA', 96, 143); g.fillText('SYRIA', 420, 366);
    /* towns (skipped where a marker card already names the place) */
    try { g.letterSpacing = '0.6px'; } catch (e) {}
    g.font = '600 7.5px ' + FONT;
    var taken = [lbXY(LB_HQ.lon, LB_HQ.lat), lbXY(LB_HUB.lon, LB_HUB.lat)]; if (lbDest) taken.push(lbXY(lbDest.lon, lbDest.lat));
    LB_TOWNS.forEach(function(t){
      var p = lbXY(t[1], t[2]);
      for (var k = 0; k < taken.length; k++) if (Math.hypot(taken[k].x - p.x, taken[k].y - p.y) < 18) return;
      g.beginPath(); g.arc(p.x, p.y, 1.8, 0, Math.PI * 2); g.fillStyle = 'rgba(255,255,255,0.75)'; g.fill();
      g.textAlign = t[3] < 0 ? 'right' : 'left'; g.fillStyle = 'rgba(255,255,255,0.62)';
      g.fillText(t[0], p.x + t[3] * 7, p.y + 2.6);
    });
    /* scale bar (25 km) + north mark */
    var km25 = (25 / 111.2) * LB_K, bx = 40, by = SZ - 26;
    g.strokeStyle = 'rgba(255,255,255,0.6)'; g.lineWidth = 1; g.beginPath(); g.moveTo(bx, by - 4); g.lineTo(bx, by); g.lineTo(bx + km25, by); g.lineTo(bx + km25, by - 4); g.stroke();
    g.font = '600 6.5px ' + FONT; g.fillStyle = 'rgba(255,255,255,0.5)'; g.textAlign = 'left'; try { g.letterSpacing = '1px'; } catch (e) {}
    g.fillText('0', bx - 2, by + 9); g.fillText('25 KM', bx + km25 - 10, by + 9);
    g.beginPath(); g.moveTo(SZ - 30, 40); g.lineTo(SZ - 26, 52); g.lineTo(SZ - 30, 49); g.lineTo(SZ - 34, 52); g.closePath(); g.fillStyle = 'rgba(255,255,255,0.6)'; g.fill();
    g.textAlign = 'center'; g.fillText('N', SZ - 30, 34);
    return c;
  }
  function lbCard(cx, cy, l1, l2, anchor){
    /* anchor: 'above' (centred over a pin) | 'left' (card sits on the sea side of a coastal point) */
    ctx.font = 'bold 8.5px -apple-system,Segoe UI,sans-serif'; var w1 = ctx.measureText(l1).width;
    ctx.font = '600 6.5px -apple-system,Segoe UI,sans-serif'; var w2 = l2 ? ctx.measureText(l2).width : 0;
    var w = Math.max(w1, w2) + 16, h = l2 ? 25 : 18;
    var x = anchor === 'left' ? cx - 12 - w : cx - w / 2, y = anchor === 'left' ? cy - h / 2 : cy - 18 - h;
    x = Math.max(4, Math.min(SZ - w - 4, x)); y = Math.max(4, y);
    ctx.save(); ctx.shadowColor = 'rgba(0,0,0,0.6)'; ctx.shadowBlur = 8; ctx.fillStyle = '#fff'; ctx.fillRect(x, y, w, h); ctx.restore();
    if (anchor === 'left') { ctx.beginPath(); ctx.moveTo(x + w, cy); ctx.lineTo(cx - 6, cy); }
    else { ctx.beginPath(); ctx.moveTo(cx, y + h); ctx.lineTo(cx, cy - 8); }
    ctx.strokeStyle = 'rgba(255,255,255,0.55)'; ctx.lineWidth = 1; ctx.stroke();
    ctx.textAlign = 'left'; ctx.fillStyle = '#000'; ctx.font = 'bold 8.5px -apple-system,Segoe UI,sans-serif'; ctx.fillText(l1, x + 8, y + (l2 ? 11 : 12));
    if (l2) { ctx.fillStyle = 'rgba(0,0,0,0.6)'; ctx.font = '600 6.5px -apple-system,Segoe UI,sans-serif'; ctx.fillText(l2, x + 8, y + 20); }
  }
  /* one leg = quadratic curve with a gentle bow; returns a point sampler */
  function lbLeg(a, b, bow){
    var mx = (a.x + b.x) / 2, my = (a.y + b.y) / 2, cx = mx - (b.y - a.y) * bow, cy = my + (b.x - a.x) * bow;
    return function(t){ var u = 1 - t; return { x: u*u*a.x + 2*u*t*cx + t*t*b.x, y: u*u*a.y + 2*u*t*cy + t*t*b.y }; };
  }
  function lbStroke(leg, t0, t1){ ctx.beginPath(); for (var i = 0; i <= 32; i++) { var q = leg(t0 + (t1 - t0) * i / 32); if (i) ctx.lineTo(q.x, q.y); else ctx.moveTo(q.x, q.y); } ctx.stroke(); }
  function drawLebanon(){
    var key = KPX + '|' + lbRegion + '|' + (lbDest ? lbDest.lon + ',' + lbDest.lat : '');
    if (!lbBase || lbBaseKey !== key) { lbBase = lbBuildBase(); lbBaseKey = key; }
    ctx.clearRect(0, 0, SZ, SZ);
    ctx.drawImage(lbBase, 0, 0, SZ, SZ);

    var hq = lbXY(LB_HQ.lon, LB_HQ.lat), hub = lbXY(LB_HUB.lon, LB_HUB.lat);
    var dst = lbDest ? lbXY(lbDest.lon, lbDest.lat) : null;
    var nearHub = dst && Math.hypot(dst.x - hub.x, dst.y - hub.y) < 16, nearHq = dst && Math.hypot(dst.x - hq.x, dst.y - hq.y) < 16;
    var legs = [lbLeg(hq, hub, 0.08)]; if (dst && !nearHub) legs.push(lbLeg(hub, dst, 0.16));
    var maxU = legs.length, pulse = (Math.sin(frame * 0.06) + 1) / 2, dp = (frame % 110) / 110;
    var u = Math.max(0, Math.min(maxU, lbU + (lbStage === 3 || lbStage === 1 ? Math.sin(frame * 0.025) * 0.012 : 0)));

    /* planned route: marching dashes */
    ctx.lineCap = 'butt'; ctx.setLineDash([5, 4]); ctx.lineDashOffset = -(frame * 0.25) % 9;
    ctx.strokeStyle = 'rgba(255,255,255,0.45)'; ctx.lineWidth = 1.6;
    legs.forEach(function(L){ lbStroke(L, 0, 1); });
    ctx.setLineDash([]); ctx.lineDashOffset = 0;
    /* travelled part */
    if (u > 0.01) {
      ctx.save(); ctx.shadowColor = 'rgba(255,255,255,0.7)'; ctx.shadowBlur = 10; ctx.strokeStyle = '#fff'; ctx.lineWidth = 2.6; ctx.lineCap = 'round';
      legs.forEach(function(L, i){ var t = Math.max(0, Math.min(1, u - i)); if (t > 0) lbStroke(L, 0, t); });
      ctx.restore();
    }
    /* stops: HQ = square, RTD hub = diamond */
    ctx.fillStyle = '#fff'; ctx.fillRect(hq.x - 4.5, hq.y - 4.5, 9, 9);
    ctx.save(); ctx.translate(hub.x, hub.y); ctx.rotate(Math.PI / 4); ctx.fillRect(-4.5, -4.5, 9, 9); ctx.restore();
    /* courier: a disc with a heading arrow */
    if (u < maxU - 0.005 || !dst) {
      var li = Math.min(legs.length - 1, Math.floor(u)), lt = Math.min(1, u - li), m = legs[li](lt), a2 = legs[li](Math.min(1, lt + 0.04)), a1 = legs[li](Math.max(0, lt - 0.04));
      var ang = Math.atan2(a2.y - a1.y, a2.x - a1.x);
      ctx.beginPath(); ctx.arc(m.x, m.y, 9 + pulse * 10, 0, Math.PI * 2); ctx.strokeStyle = 'rgba(255,255,255,' + (0.5 * (1 - pulse)) + ')'; ctx.lineWidth = 1.2; ctx.stroke();
      ctx.save(); ctx.shadowColor = 'rgba(0,0,0,0.6)'; ctx.shadowBlur = 6; ctx.beginPath(); ctx.arc(m.x, m.y, 8, 0, Math.PI * 2); ctx.fillStyle = '#fff'; ctx.fill(); ctx.restore();
      ctx.save(); ctx.translate(m.x, m.y); ctx.rotate(ang); ctx.beginPath(); ctx.moveTo(4.6, 0); ctx.lineTo(-3, -3.6); ctx.lineTo(-1.2, 0); ctx.lineTo(-3, 3.6); ctx.closePath(); ctx.fillStyle = '#000'; ctx.fill(); ctx.restore();
    }
    /* destination */
    if (dst) {
      ctx.beginPath(); ctx.arc(dst.x, dst.y, 7 + dp * 26, 0, Math.PI * 2); ctx.strokeStyle = 'rgba(255,255,255,' + (0.55 * (1 - dp)) + ')'; ctx.lineWidth = 1.5; ctx.stroke();
      ctx.beginPath(); ctx.arc(dst.x, dst.y, 6.5, 0, Math.PI * 2); ctx.fillStyle = '#fff'; ctx.fill();
      ctx.beginPath(); ctx.arc(dst.x, dst.y, 2.6, 0, Math.PI * 2); ctx.fillStyle = '#000'; ctx.fill();
    }
    /* cards last so nothing draws over them; a stop that coincides with the destination keeps only the destination card */
    if (!nearHq) lbCard(hq.x, hq.y, 'JERZIFY HQ', 'SAIDA', 'left');
    if (!nearHub) lbCard(hub.x, hub.y, 'RTD HUB', 'BEIRUT · COLA', 'left');
    if (dst) lbCard(dst.x, dst.y, lbDest.label, lbStatus, 'above');
    frame++;
    if (Math.abs(lbU - lbUTarget) > 0.0005) lbU += (lbUTarget - lbU) * 0.02;
  }

  /* Itinerary under the map — DOM, so it stays crisp and readable on any screen. Follows the active scene. */
  var routeEl = document.getElementById('trkRoute'), routeInfo = null;
  function renderRoute(){
    if (!routeEl) return;
    if (!routeInfo) { routeEl.classList.add('trk-hidden'); routeEl.innerHTML = ''; return; }
    var st = routeInfo.stage, s = lbStage, stops;
    if (scene === 'lb') {
      stops = [['Jerzify HQ', 'Saida', s >= 1 ? 'done' : 'active'],
               ['RTD hub', 'Beirut · Cola', s >= 3 ? 'done' : (s >= 1 ? 'active' : '')],
               [routeInfo.city || 'Your address', s >= 4 ? 'Delivered' : (s === 3 ? 'Out for delivery' : 'Destination'), s >= 4 ? 'done' : (s === 3 ? 'active' : '')]];
    } else {
      stops = [['Jerzify China', 'Guangzhou hub', st >= 2 ? 'done' : 'active'],
               ['In the air', st === 2 && routeInfo.day ? 'Day ' + routeInfo.day : 'Air freight', st >= 3 ? 'done' : (st === 2 ? 'active' : '')],
               [routeInfo.country || 'Destination', st >= 5 ? 'Delivered' : (st >= 3 ? 'Arrived' : 'Destination'), st >= 5 ? 'done' : (st >= 3 ? 'active' : '')]];
    }
    routeEl.innerHTML = stops.map(function(p, i){
      return '<li class="trk-route__stop' + (p[2] ? ' is-' + p[2] : '') + '"><span class="trk-route__n">0' + (i + 1) + '</span><span class="trk-route__t">' + esc(p[0]) + '</span><span class="trk-route__s">' + esc(p[1]) + '</span></li>';
    }).join('');
    routeEl.classList.remove('trk-hidden');
  }

  var sceneWrap = document.getElementById('trkTop'), sceneBar = document.getElementById('trkScene'), hintEl = document.getElementById('globeHint');
  var HINTS = { globe: hintEl ? hintEl.textContent : '', lb: 'Jerzify HQ in Saida → RTD hub in Beirut → your city · the courier position follows RTD scans' };
  function syncScene(){
    var m = scene === 'lb';
    cvs.classList.toggle('is-map', m); if (sceneWrap) sceneWrap.classList.toggle('is-map', m);
    if (hintEl) hintEl.textContent = HINTS[scene];
    if (sceneBar) [].slice.call(sceneBar.querySelectorAll('[data-scene]')).forEach(function(b){ b.setAttribute('aria-pressed', b.getAttribute('data-scene') === scene ? 'true' : 'false'); });
    renderRoute();
  }
  function setScene(s){
    if (s === 'lb' && !LBMAP) s = 'globe';
    if (s === scene) { syncScene(); return; }
    cvs.classList.add('is-switching');
    setTimeout(function(){ scene = s; dragging = false; syncScene(); cvs.classList.remove('is-switching'); }, 200);
  }
  if (sceneBar) sceneBar.addEventListener('click', function(e){ var b = e.target.closest('[data-scene]'); if (b) setScene(b.getAttribute('data-scene')); });

  var onScreen = true;
  if ('IntersectionObserver' in window) new IntersectionObserver(function(en){ onScreen = en[0].isIntersecting; }).observe(cvs);
  function loop(){ if (onScreen && !document.hidden) { if (scene === 'lb') drawLebanon(); else drawGlobe(); } requestAnimationFrame(loop); }

  /* ─── Drag (rotate) + zoom ─── */
  function zoomBy(f){ if(scene!=='globe')return; targetR=Math.max(MINR,Math.min(MAXR,targetR*f)); userMoved=true; userZoom=targetR>R*1.04; cvs.classList.toggle('is-zoomed',userZoom); }
  /* Rotation speed scales down with zoom so dragging stays precise at ultra zoom
     (fixed 0.008 rad/px made the surface fly past when zoomed in). */
  function dragScale(){ return 0.008 * (R/displayR); }
  cvs.addEventListener('mousedown',function(e){if(scene!=='globe')return;dragging=true;lastX=e.clientX;lastY=e.clientY;});
  window.addEventListener('mousemove',function(e){
    if(!dragging)return;
    var ds=dragScale();
    rotY-=(e.clientX-lastX)*ds; rotX+=(e.clientY-lastY)*ds;
    rotX=Math.max(-Math.PI/2,Math.min(Math.PI/2,rotX));
    lastX=e.clientX;lastY=e.clientY;userMoved=true;
  });
  window.addEventListener('mouseup',function(){dragging=false;});
  /* Mouse wheel / trackpad zoom */
  cvs.addEventListener('wheel',function(e){if(scene!=='globe')return;e.preventDefault();zoomBy(e.deltaY<0?1.12:1/1.12);},{passive:false});
  /* Touch: one finger rotates, two fingers pinch-zoom */
  cvs.addEventListener('touchstart',function(e){
    if(scene!=='globe')return;
    if(e.touches.length>=2){
      pinching=true;
      pinchDist=Math.hypot(e.touches[0].clientX-e.touches[1].clientX,e.touches[0].clientY-e.touches[1].clientY);
      e.preventDefault();return;
    }
    if(userZoom)e.preventDefault();   /* at home zoom the canvas is touch-action:pan-y → page scroll wins vertically */
    dragging=true;lastX=e.touches[0].clientX;lastY=e.touches[0].clientY;
  },{passive:false});
  cvs.addEventListener('touchmove',function(e){
    if(scene!=='globe')return;
    if(e.cancelable&&(pinching||userZoom))e.preventDefault();
    if(pinching&&e.touches.length>=2){
      var d=Math.hypot(e.touches[0].clientX-e.touches[1].clientX,e.touches[0].clientY-e.touches[1].clientY);
      if(pinchDist)zoomBy(d/pinchDist);
      pinchDist=d;return;
    }
    if(!dragging)return;
    var tds=dragScale();
    rotY-=(e.touches[0].clientX-lastX)*tds; rotX+=(e.touches[0].clientY-lastY)*tds;
    rotX=Math.max(-Math.PI/2,Math.min(Math.PI/2,rotX));
    lastX=e.touches[0].clientX;lastY=e.touches[0].clientY;userMoved=true;
  },{passive:false});
  cvs.addEventListener('touchend',function(e){if(e.touches.length<2)pinching=false;if(e.touches.length===0)dragging=false;});

  /* ─── Plane click ─── */
  function handlePlaneClick(cx, cy) {
    if(scene!=='globe'||!planeVisible||!ARC.length||!currentData)return;
    var rect=cvs.getBoundingClientRect();
    var sx=SZ/rect.width, sy=SZ/rect.height;
    var mx=(cx-rect.left)*sx, my=(cy-rect.top)*sy;
    if(Math.sqrt((mx-planePx)*(mx-planePx)+(my-planePy)*(my-planePy))<38){
      showPlanePopup();
    }
  }
  cvs.addEventListener('click',function(e){handlePlaneClick(e.clientX,e.clientY);});
  cvs.addEventListener('touchend',function(e){
    if(e.changedTouches.length)handlePlaneClick(e.changedTouches[0].clientX,e.changedTouches[0].clientY);
  });

  loop();

  /* ═══════════════════════════════════════
     HELPERS
  ═══════════════════════════════════════ */
  function show(el){el.classList.remove('trk-hidden');}
  function hide(el){el.classList.add('trk-hidden');}
  function addDays(d,n){var r=new Date(d);r.setDate(r.getDate()+n);return r;}
  function fmtShort(d){return new Date(d).toLocaleDateString('en-US',{month:'short',day:'numeric'});}
  function fmtFull(d){return new Date(d).toLocaleDateString('en-US',{month:'long',day:'numeric',year:'numeric'});}

  var STAGE_LABELS=['Confirmed','Processing','Shipped','Arrived','Local Delivery','Delivered'];
  var SRC_LABEL={supplier:'Dispatched from our atelier',admin:'Updated by Jerzify',rtd:'Local courier (RTD)',carrier:'Carrier update',system:''};
  function fmtDateTime(d){return new Date(d).toLocaleDateString('en-US',{month:'short',day:'numeric',hour:'2-digit',minute:'2-digit'});}
  function esc(s){return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}

  /* ─── Set globe route ─── */
  function setRoute(lon, lat, label, stage, initProgress) {
    userMoved=false;   /* a new track re-centers the camera on the order */
    userZoom=false; cvs.classList.remove('is-zoomed');
    var dLon=Math.abs(lon-ORIGIN.lon), dLat=Math.abs(lat-ORIGIN.lat);
    sameCountry=(dLon<3&&dLat<3);
    DEST={lon:lon,lat:lat,label:label};
    ARC=sameCountry?[]:computeArc(ORIGIN,DEST,90);
    currentStage=stage;
    var prog=initProgress||0;
    if(stage>=3){
      /* Delivered/local delivery — zoom into destination */
      targetR=Math.round(R*1.32);
      lockedY=lon*Math.PI/180;
      lockedX=lat*Math.PI/180;
    }else if(stage>=2&&ARC.length){
      /* In transit — immediately center globe on WHERE THE PLANE IS RIGHT NOW */
      targetR=R;
      var pidx=Math.round(Math.min(Math.max(prog,0.01),0.99)*(ARC.length-1));
      lockedY=ARC[pidx].lon*Math.PI/180;
      lockedX=ARC[pidx].lat*Math.PI/180;
    }else{
      /* Confirmed/Processing/same-country — center on Beirut */
      targetR=R;
      lockedY=ORIGIN.lon*Math.PI/180;
      lockedX=ORIGIN.lat*Math.PI/180;
    }
  }

  /* ─── 5-step timeline ─── */
  function renderTimeline(stage, placed) {
    var pcts=[0,20,40,60,80,100];
    document.getElementById('trkTlProg').style.width=pcts[Math.min(stage,5)]+'%';
    var dates=[
      fmtShort(placed),
      fmtShort(addDays(placed,1)),
      fmtShort(addDays(placed,PROC)),
      fmtShort(addDays(placed,PROC+SHIP-5)),
      fmtShort(addDays(placed,PROC+SHIP)),
      fmtShort(addDays(placed,PROC+SHIP+5)),
    ];
    for(var i=0;i<=5;i++){
      var el=document.getElementById('tlS'+i);
      el.className='trk-tl__step '+(i<stage?'done':i===stage?'active':'future');
      document.getElementById('tlD'+i).textContent=i<=stage?dates[i]:'';
    }
  }

  /* ─── Status suggestion + estimated delivery ─── */
  function renderEstimate(data,stage){
    var country=data.shipping_country||'your country';
    var SUG=[
      {t:'Order Confirmed',s:"We've received your order and will begin preparing it shortly."},
      {t:'Preparing Your Order',s:'Our team is getting your items ready for dispatch.'},
      {t:'On Its Way',s:'Your order has shipped and is on its way to '+country+'.'},
      {t:'Arrived in '+country,s:'Your order has landed and is being handed to our local courier for delivery.'},
      {t:'Out for Delivery',s:'Your order is in your area and arriving very soon.'},
      {t:'Delivered',s:'Your order has been delivered — enjoy your gear!'}
    ];
    var sg=SUG[Math.min(stage,5)];
    document.getElementById('trkEstIcon').textContent='0'+(Math.min(stage,5)+1);
    var estBar=document.getElementById('trkEstBar'); if(estBar) estBar.style.width=((Math.min(stage,5)+1)/6*100)+'%';
    document.getElementById('trkEstTitle').textContent=sg.t;
    document.getElementById('trkEstSub').textContent=sg.s; /* delay_note has its own panel (#trkNote) */

    var etaEl=document.getElementById('trkEstEta');
    etaEl.classList.remove('delivered');
    if(stage>=5){
      etaEl.innerHTML='Delivered';
      etaEl.classList.add('delivered');
    }else if(stage>=4){
      /* Out for local delivery */
      etaEl.innerHTML='Arriving today–tomorrow';
    }else if(stage>=3){
      /* Arrived in country / customs — narrow the window */
      etaEl.innerHTML='2–4 days<span class="trk-est__eta-sub">final delivery leg</span>';
    }else{
      /* 3–4 week window; show the outer-bound "by" date so we under-promise */
      var target=addDays(data.created_at,PROC+SHIP+5);
      if(Date.now()>target.getTime()){
        etaEl.innerHTML='Arriving any day now';
      }else{
        etaEl.innerHTML='3–4 weeks<span class="trk-est__eta-sub">by '+fmtFull(target)+'</span>';
      }
    }
    show(document.getElementById('trkEst'));
  }

  /* ─── RTD last-mile: map a status text → stage / icon / exception ─── */
  function rtdStageInfo(text){
    var t=(text||'').toLowerCase();
    if(/return/.test(t))                          return {stage:-1,exc:'returning'};
    if(/fail/.test(t))                            return {stage:-1,exc:'failed'};
    if(/re.?sched|reschedul|on hold|postpon/.test(t)) return {stage:-1,exc:'rescheduled'};
    if(/retry|re.?attempt|retrying/.test(t))      return {stage:-1,exc:'retrying'};
    if(/(deliver).*(man|driver|assign|agent)|out for deliver/.test(t)) return {stage:3};
    if(/delivered|handed|received by/.test(t))    return {stage:4};
    if(/hub|warehouse|received|transfer|sorting|arrived|in.?transit|transit/.test(t)) return {stage:2};
    if(/pickup|picked|collect|accepted/.test(t))  return {stage:1};
    if(/pending|created|registered/.test(t))      return {stage:0};
    return {stage:0};
  }

  /* ─── RTD last-mile tracking bar (Lebanon local leg) ─── */
  function renderRtd(data, mainStage){
    mainStage=mainStage||0;
    var box=document.getElementById('trkRtd');
    var rtd=data&&data.rtd;
    var evs=(rtd&&Array.isArray(rtd.events))?rtd.events.filter(function(e){return e&&(e.status||e.desc||e.date);}):[];
    var hasRtd=!!(rtd&&(rtd.tracking_number||evs.length));
    var inLastMile=mainStage>=3;   /* order has reached Lebanon → the last-mile leg has begun */
    if(!hasRtd&&!inLastMile){hide(box);return;}
    evs=evs.slice().sort(function(a,b){return new Date(b.date)-new Date(a.date);}); /* newest first */

    /* Last-mile stage + latest-exception. When RTD hasn't scanned yet, derive the stage from the
       order's main stage (Arrived→Picked Up, Local Delivery→Out for Delivery, Delivered→Delivered). */
    var curStage=0;
    evs.forEach(function(e){var inf=rtdStageInfo(e.status||e.desc);if(inf.stage>curStage)curStage=inf.stage;});
    if(!evs.length){ curStage=(mainStage>=5)?4:(mainStage>=4)?3:(mainStage>=3)?1:0; }
    var latest=evs[0]||null;
    var latestInf=latest?rtdStageInfo(latest.status||latest.desc):{stage:curStage};
    var delivered=curStage>=4;
    var STAGES=['Picked Up','At Hub','Out for Delivery','Delivered'];

    var badgeCls=delivered?'is-delivered':(latestInf.exc?'is-exc':'');
    var badgeTxt=delivered?'Delivered':(latest?(latest.status||'In Progress'):(curStage>=3?'Out for Delivery':curStage>=1?'In Transit':'Awaiting Pickup'));

    var h='';
    /* Header */
    h+='<div class="trk-rtd__head">';
    h+='<div class="trk-rtd__ht"><div class="trk-rtd__title">Last-Mile Delivery · RTD Express</div>';
    h+='<div class="trk-rtd__num">'+((rtd&&rtd.tracking_number)?('#'+esc(rtd.tracking_number)):'Awaiting courier assignment')+
       ((rtd&&rtd.tracking_url)?' <a href="'+esc(rtd.tracking_url)+'" target="_blank" rel="noopener">Track ↗</a>':'')+'</div></div>';
    h+='<span class="trk-rtd__badge '+badgeCls+'">'+esc(badgeTxt)+'</span></div>';

    /* Active exception banner (failed / rescheduled / retrying / returning) */
    if(latestInf.exc){
      var warn=(latestInf.exc==='rescheduled'||latestInf.exc==='retrying');
      var msg={failed:'A delivery attempt was unsuccessful. The courier will try again.',
               rescheduled:'Your delivery has been rescheduled — the courier will re-attempt soon.',
               retrying:'The courier is re-attempting your delivery.',
               returning:'This parcel is being returned. Please contact us if this is unexpected.'}[latestInf.exc];
      h+='<div class="trk-rtd__alert'+(warn?' is-warn':'')+'"><div>'+
         '<strong>'+esc(latest?(latest.status||'Update'):'Update')+'</strong> — '+esc(latest&&latest.desc?latest.desc:msg)+(CFG.help?' <a class="trk-rtd__alert-cta" href="'+esc(helpUrl())+'" target="_blank" rel="noopener">Message us on WhatsApp</a>':'')+'</div></div>';
    }

    /* 4-stage last-mile progress bar */
    h+='<div class="trk-rtd__prog">';
    for(var i=0;i<4;i++){
      var on=curStage>=(i+1), done=(i===3&&delivered);
      h+='<div class="trk-rtd__seg'+(on?' on':'')+(done?' done':'')+'"><div class="trk-rtd__bar"></div>'+
         '<div class="trk-rtd__lbl">'+STAGES[i]+'</div></div>';
    }
    h+='</div>';

    /* Full RTD event log — every scan (picked up, failed, rescheduled, retrying, delivered…) */
    if(evs.length){
      h+='<div class="trk-rtd__evh">Courier Activity</div><div class="trk-events">';
      evs.forEach(function(e){
        h+='<div class="trk-event"><div class="trk-event__dot"></div><div class="trk-event__info">'+
           '<div class="trk-event__status">'+esc(e.status||'Courier update')+'</div>'+
           (e.desc?'<div class="trk-event__loc">'+esc(e.desc)+'</div>':'')+
           (e.date?'<div class="trk-event__date">'+fmtDateTime(e.date)+'</div>':'')+
           '</div></div>';
      });
      h+='</div>';
    }else{
      h+='<div class="trk-rtd__evh">Courier Activity</div>'+
         '<div class="trk-events"><div class="trk-events__empty">Your parcel is with RTD for local delivery. Each courier scan — picked up, out for delivery, any re-attempt, and delivered — will appear here as it happens.</div></div>';
    }
    box.innerHTML=h;
    show(box);
  }

  /* ─── Reset timeline ─── */
  function resetTimeline(){
    document.getElementById('trkTlProg').style.width='0%';
    for(var i=0;i<=5;i++){
      document.getElementById('tlS'+i).className='trk-tl__step future';
      document.getElementById('tlD'+i).textContent='';
    }
  }

  /* ─── Plane popup ─── */
  function showPlanePopup(){
    if(!currentData||!DEST)return;
    document.getElementById('popupDest').textContent=DEST.label||'DESTINATION';
    var etaD=currentData.eta?new Date(currentData.eta):(currentData.created_at?addDays(currentData.created_at,PROC+SHIP+5):null);
    document.getElementById('popupEta').textContent=etaD?fmtFull(etaD):'—';
    document.getElementById('popupStage').textContent=STAGE_LABELS[Math.min(currentStage,5)]||'—';
    var pcRow=document.getElementById('popupCarrierRow');
    if(currentData.carrier_tracking&&currentData.carrier_tracking.carrier&&CARRIERS[currentData.carrier_tracking.carrier]){
      var ci=CARRIERS[currentData.carrier_tracking.carrier];
      var logo=document.getElementById('popupCarrierLogo');
      if(ci.logo){logo.src=ci.logo;logo.alt=ci.name;logo.style.display='';}else{logo.style.display='none';}
      document.getElementById('popupCarrierName').textContent=ci.name;
      document.getElementById('popupTrackNum').textContent='#'+currentData.carrier_tracking.tracking_number;
      show(pcRow);
    }else{hide(pcRow);}
    show(document.getElementById('planePopup'));
  }

  document.getElementById('popupClose').addEventListener('click',function(){hide(document.getElementById('planePopup'));});
  document.getElementById('popupBackdrop').addEventListener('click',function(){hide(document.getElementById('planePopup'));});

  /* ─── Render order ─── */
  function render(data){
    currentData=data;
    var stage=Math.min(data.stage_index,5);
    currentStage=stage;

    /* Globe — pre-compute progress so globe snaps to plane position immediately */
    var country=data.shipping_country||'Lebanon';
    var coords=resolveCoords(country)||COUNTRY['Lebanon'];
    /* Mutually exclusive: showing the local order detail hides any international result. */
    hide(document.getElementById('intlResult'));
    var total=PROC+SHIP;
    var days=data.days_since_order||0;
    var dLon2=Math.abs(coords[0]-ORIGIN.lon),dLat2=Math.abs(coords[1]-ORIGIN.lat);
    var isLocal=(dLon2<3&&dLat2<3);
    var newProg=(stage>=3)?1:(stage<=1||isLocal)?0:Math.min(Math.max(days/total,0.08),0.96);
    setRoute(coords[0],coords[1],country.toUpperCase(),stage,newProg);
    targetProgress=newProg;
    /* Jump plane animation near correct spot so globe tracks immediately */
    if(newProg>0&&planeProgress<newProg-0.05) planeProgress=Math.max(0,newProg-0.08);

    /* Globe status message */
    var statusEl=document.getElementById('globeStatus');
    if(statusEl){
      var msgs=['Order Confirmed · Preparing for shipment','Being Prepared · Dispatching soon','In Transit · Flying to '+country,'Arrived · Clearing customs in '+country,'Out for Delivery · Almost there','Delivered · Enjoy your order'];
      statusEl.textContent=msgs[Math.min(stage,5)];
      show(statusEl);
    }

    /* Timeline */
    renderTimeline(stage,data.created_at);

    /* Status suggestion + estimated delivery */
    renderEstimate(data,stage);

    /* ── Unified detail: ONE tracking view chosen by destination ──
       · Lebanon  → RTD last-mile bar (real fulfillment events: picked up / failed / delivered…).
       · Worldwide → live carrier tracking, auto-fetched from the order's own tracking number —
         the customer never types it; we show it for them. */
    var isLB=/lebanon/i.test(String(country||''))||String(country||'').toUpperCase()==='LB';
    /* Lebanon: once the parcel has landed, swap the globe for the last-mile map (toggle stays available). */
    lbAvail=isLB&&!!LBMAP;
    if(sceneBar)sceneBar.classList.toggle('trk-hidden',!lbAvail);
    if(lbAvail){
      var lc=lbLookup(data.shipping_city);
      lbDest=lc?{lon:lc[0],lat:lc[1],label:String(data.shipping_city).trim().toUpperCase()}:null;
      lbRegion=lbDest?lbRegionAt(lbDest.lon,lbDest.lat):-1;
      lbStatus=stage>=5?'DELIVERED':stage>=4?'OUT FOR DELIVERY':stage>=3?'ARRIVED IN LEBANON':'DESTINATION';
      lbUTarget=lbProgressFor(data,stage); lbU=Math.max(0,lbUTarget-0.5);
    }
    routeInfo={stage:stage,country:country,city:(data.shipping_city?String(data.shipping_city).trim():''),day:data.days_since_order||0};
    setScene(lbAvail&&stage>=3?'lb':'globe');
    var ir=document.getElementById('intlResult');
    if(isLB){
      hide(ir);
      renderRtd(data, stage);
    }else{
      hide(document.getElementById('trkRtd'));
      var ct=data.carrier_tracking;
      if(ct&&ct.tracking_number){
        autoIntl(ct.tracking_number,(data.intl&&data.intl.carrier)||ct.carrier||'');
      }else{
        ir.innerHTML='<div class="trk-intl-card"><div class="trk-events__empty">Your order hasn’t shipped yet. As soon as it’s on its way, your live worldwide tracking number and updates will appear here automatically.</div></div>';
        show(ir);
      }
    }

    /* Delay note */
    var noteEl=document.getElementById('trkNote');
    if(data.delay_note){noteEl.textContent=data.delay_note;show(noteEl);}else{hide(noteEl);}

    /* Meta */
    document.getElementById('trkMetaNum').textContent=data.order_number;
    document.getElementById('trkMetaDate').textContent=fmtFull(data.created_at);
    document.getElementById('trkMetaStatus').textContent=(data.financial_status||'').replace(/_/g,' ').replace(/\b\w/g,function(c){return c.toUpperCase();});
    var destEl=document.getElementById('trkMetaDest');
    if(destEl)destEl.textContent=[data.shipping_city,data.shipping_country].filter(Boolean).join(', ')||'—';

    /* Items — built with DOM API to avoid innerHTML escaping issues */
    var list=document.getElementById('trkItems');
    list.innerHTML='';
    (data.line_items||[]).forEach(function(item){
      var card=document.createElement('div');
      card.className='trk-pcard';

      var wrap=document.createElement('div');
      wrap.className='trk-pcard__img-wrap';

      function ph(w){var d=document.createElement('div');d.className='trk-pcard__ph';w.innerHTML='';w.appendChild(d);}

      function makeImg(src,alt,w){
        /* Request a crisp, right-sized image from the Shopify CDN (2× the 92px slot). */
        if(src&&/cdn\.shopify\.com/.test(src)&&src.indexOf('width=')<0){src+=(src.indexOf('?')>-1?'&':'?')+'width=220';}
        var img=document.createElement('img');
        img.src=src;img.alt=alt;img.loading='lazy';img.width=184;img.height=184;img.decoding='async';
        img.onerror=function(){ph(w);};
        w.innerHTML='';w.appendChild(img);
      }

      /* Image loading: 4-layer fallback chain */
      function guessHandle(t){return t.toLowerCase().replace(/[^a-z0-9\s]/g,'').trim().replace(/\s+/g,'-');}
      function tryHandle(w,handle,title,onFail){
        fetch('/products/'+handle+'.js')
        .then(function(r){if(!r.ok)throw 0;return r.json();})
        .then(function(p){
          var src=p.featured_image;if(!src)throw 0;
          if(src.startsWith('//'))src='https:'+src;
          makeImg(src,p.title||title,w);
        }).catch(onFail||function(){ph(w);});
      }
      function trySearch(w,title){
        fetch('/search/suggest.json?q='+encodeURIComponent(title.split(' ').slice(0,4).join(' '))+'&resources[type]=product&resources[limit]=1')
        .then(function(r){return r.json();})
        .then(function(d){
          var prods=d.resources&&d.resources.results&&d.resources.results.products;
          var img=prods&&prods[0]&&prods[0].featured_image&&prods[0].featured_image.url;
          if(img)makeImg(img,title,w);else ph(w);
        }).catch(function(){ph(w);});
      }
      if(item.image){
        makeImg(item.image,item.title,wrap);
      }else if(item.handle){
        ph(wrap);
        (function(w,h,t){tryHandle(w,h,t,function(){trySearch(w,t);});})(wrap,item.handle,item.title);
      }else{
        ph(wrap);
        (function(w,t){tryHandle(w,guessHandle(t),t,function(){trySearch(w,t);});})(wrap,item.title);
      }

      var info=document.createElement('div');info.className='trk-pcard__info';
      var nameEl=document.createElement('div');nameEl.className='trk-pcard__name';nameEl.textContent=item.title;
      if(item.quantity>1){var qty=document.createElement('span');qty.className='trk-pcard__qty';qty.textContent='×'+item.quantity;nameEl.appendChild(qty);}
      info.appendChild(nameEl);
      if(item.variant_title&&item.variant_title!=='Default Title'){var v=document.createElement('div');v.className='trk-pcard__var';v.textContent=item.variant_title;info.appendChild(v);}

      /* Personalization chips (Name / Number / Patch …) with icons */
      var props=(item.personalization||[]).filter(function(p){return p&&p.name&&p.value;});
      if(props.length){
        var pbox=document.createElement('div');pbox.className='trk-pcard__props';
        props.forEach(function(p){
          var nm=String(p.name);
          var chip=document.createElement('span');chip.className='trk-pcard__chip';
          if(/patch/i.test(nm)&&item.patch_image){
            var pimg=document.createElement('img');pimg.src=item.patch_image;pimg.alt='Patch';pimg.loading='lazy';
            pimg.onerror=function(){this.style.display='none';};
            chip.appendChild(pimg);
          }
          var st=document.createElement('strong');st.textContent=nm+':';chip.appendChild(st);
          chip.appendChild(document.createTextNode(' '+p.value));
          pbox.appendChild(chip);
        });
        info.appendChild(pbox);
      }

      var pr=document.createElement('div');pr.className='trk-pcard__price';pr.textContent=item.price;info.appendChild(pr);

      card.appendChild(wrap);card.appendChild(info);
      list.appendChild(card);
    });

    document.getElementById('trkTotal').textContent=data.total_price;
    show(document.getElementById('trkDetail'));
  }

  /* ─── Track Jerzify order ───
     track() is used by the form, the deep link, the remembered order, the customer chips and the live refresh.
     Live refresh is deliberately gentle: the worker has no rate limit and every call costs Shopify Admin API
     requests, so we poll every 2 min, only while the tab is visible, stop at Delivered and after 30 polls (1 h).
     A silent refresh re-renders ONLY when something changed, so the camera/scroll are never yanked for nothing. */
  var errEl=document.getElementById('trkErr');
  var btn=document.getElementById('trkBtn');
  var numEl=document.getElementById('trkNum'), mailEl=document.getElementById('trkEmail');
  var liveTxt=document.getElementById('trkLiveTxt'), refreshBtn=document.getElementById('trkRefresh'), copyBtn=document.getElementById('trkCopy');
  var LS_KEY='jz_track_last', POLL_MS=120000, POLL_MAX=30;
  var cur=null, lastSig='', lastAt=0, pollTimer=null, tickTimer=null, polls=0, busy=false;

  function toast(m){ if(window.JZ&&JZ.util&&JZ.util.toast) JZ.util.toast(m); }
  function helpUrl(){ var h=String(CFG.help||''); if(!h) return ''; return h+(h.indexOf('?')>-1?'&':'?')+'text='+encodeURIComponent('Hi! I need help with my order'+(cur?' #'+cur.num:(numEl.value?' #'+numEl.value.replace(/^#/,''):''))); }
  function setErr(msg, withHelp){
    errEl.textContent=''; if(!msg) return;
    errEl.appendChild(document.createTextNode(msg));
    if(withHelp&&CFG.help){ errEl.appendChild(document.createTextNode(' ')); var a=document.createElement('a'); a.href=helpUrl(); a.target='_blank'; a.rel='noopener'; a.className='link'; a.textContent='Message us on WhatsApp'; errEl.appendChild(a); }
  }
  function sigOf(d){ try{ return JSON.stringify([d.stage_index,d.delay_note||'',d.financial_status||'',d.rtd?[d.rtd.tracking_number||'',(d.rtd.events||[]).length,((d.rtd.events||[])[0]||{}).status||'']:0,d.carrier_tracking?d.carrier_tracking.tracking_number:'',(d.stage_history||[]).length]); }catch(e){ return String(Date.now()); } }
  function ago(){ var s=Math.max(0,Math.round((Date.now()-lastAt)/1000)); return s<10?'just now':s<60?s+'s ago':s<3600?Math.round(s/60)+' min ago':Math.round(s/3600)+' h ago'; }
  function paintLive(){ if(liveTxt&&lastAt) liveTxt.textContent=(currentStage>=5?'Final status':(pollTimer?'Live':'Paused'))+' · updated '+ago(); }
  function stopLive(){ if(pollTimer)clearInterval(pollTimer); if(tickTimer)clearInterval(tickTimer); pollTimer=tickTimer=null; }
  function startLive(){
    stopLive(); polls=0; tickTimer=setInterval(paintLive,15000);
    if(currentStage>=5) return;                                   /* delivered → nothing left to wait for */
    pollTimer=setInterval(function(){
      if(document.hidden||!cur||busy) return;
      if(++polls>POLL_MAX){ clearInterval(pollTimer); pollTimer=null; paintLive(); return; }
      track(cur.num,cur.email,{silent:true});
    },POLL_MS);
  }
  function remember(num,email){ try{ localStorage.setItem(LS_KEY,JSON.stringify({n:num,e:email,t:Date.now()})); }catch(e){} }
  function recall(){ try{ var o=JSON.parse(localStorage.getItem(LS_KEY)||'null'); return (o&&o.n&&o.e&&Date.now()-o.t<45*864e5)?o:null; }catch(e){ return null; } }
  function forget(){ try{ localStorage.removeItem(LS_KEY); }catch(e){} }
  function setUrl(num){ try{ var u=new URL(location.href); if(num)u.searchParams.set('order',num); else u.searchParams.delete('order'); history.replaceState(null,'',u.toString()); }catch(e){} }

  function track(num,email,opts){
    opts=opts||{}; if(busy) return; busy=true;
    if(!opts.silent){ setErr(''); btn.classList.add('is-loading'); }
    if(refreshBtn) refreshBtn.classList.add('is-busy');
    function done(){ busy=false; btn.classList.remove('is-loading'); if(refreshBtn) refreshBtn.classList.remove('is-busy'); }
    fetch(WORKER+'/track',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({order_number:num,email:email})})
    .then(function(r){return r.json();})
    .then(function(data){
      done();
      if(!data||data.error){
        if(opts.silent) return;
        if(opts.restored){ forget(); return; }                    /* a remembered order that no longer resolves: drop it quietly */
        setErr((data&&(data.message||data.error))||'Something went wrong. Please try again.',true);
        numEl.setAttribute('aria-invalid','true'); mailEl.setAttribute('aria-invalid','true');
        return;
      }
      var sig=sigOf(data), changed=sig!==lastSig;
      lastAt=Date.now();
      if(!opts.silent||changed){ lastSig=sig; cur={num:num,email:email}; render(data); }
      if(opts.silent){ if(changed) toast('Tracking updated'); else if(opts.manual) toast('No new updates yet'); }
      paintLive();
      if(!opts.silent){
        remember(num,email); setUrl(num); startLive(); paintLive();
        if(!opts.noScroll){ var top=document.getElementById('trkTop'); if(top&&top.scrollIntoView) top.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth',block:'start'}); }
      }
    })
    .catch(function(){
      done();
      if(!opts.silent&&!opts.restored) setErr('We couldn’t reach the tracking service. Check your connection and try again.');
      else if(opts.manual) toast('Couldn’t refresh — try again');
    });
  }

  function submit(){
    var num=numEl.value.trim().replace(/^#/,'').replace(/\s+/g,''), email=mailEl.value.trim();
    numEl.removeAttribute('aria-invalid'); mailEl.removeAttribute('aria-invalid');
    if(!num||!/\d{2,}/.test(num)){ setErr(num?'That doesn’t look like an order number. Use the digits after # in your confirmation, e.g. 2245.':'Enter your order number — it’s in your confirmation and starts with #.'); numEl.setAttribute('aria-invalid','true'); numEl.focus(); return; }
    if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)){ setErr(email?'Check the email address — use the one you ordered with.':'Enter the email you ordered with.'); mailEl.setAttribute('aria-invalid','true'); mailEl.focus(); return; }
    track(num,email);
  }
  btn.addEventListener('click',submit);
  if(refreshBtn) refreshBtn.addEventListener('click',function(){ if(cur) track(cur.num,cur.email,{silent:true,manual:true}); });
  if(copyBtn) copyBtn.addEventListener('click',function(){
    if(!cur) return; var link=location.origin+location.pathname+'?order='+encodeURIComponent(cur.num);
    function ok(){ toast('Tracking link copied'); }
    if(navigator.clipboard&&navigator.clipboard.writeText) navigator.clipboard.writeText(link).then(ok,function(){ window.prompt('Copy this link',link); }); else window.prompt('Copy this link',link);
  });
  /* logged-in customers: one tap on a recent order (the email field is already prefilled) */
  document.addEventListener('click',function(e){ var b=e.target.closest('[data-track-order]'); if(!b) return; numEl.value=b.getAttribute('data-track-order'); submit(); });
  document.addEventListener('visibilitychange',function(){ if(!document.hidden&&cur&&pollTimer&&Date.now()-lastAt>POLL_MS) track(cur.num,cur.email,{silent:true}); });

  ['trkNum','trkEmail'].forEach(function(id){
    document.getElementById(id).addEventListener('keydown',function(e){if(e.key==='Enter')submit();});
  });

  document.getElementById('trkReset').addEventListener('click',function(){
    planeProgress=0;targetProgress=0;DEST=null;ARC=[];sameCountry=false;
    targetR=R;currentStage=-1;currentData=null;
    lockedY=HOME.lon*Math.PI/180;lockedX=HOME.lat*Math.PI/180;userMoved=false; /* settle back on home view */
    resetTimeline();
    stopLive();cur=null;lastSig='';lastAt=0;forget();setUrl('');numEl.value='';setErr('');
    lbAvail=false;lbDest=null;lbRegion=-1;routeInfo=null;renderRoute();userZoom=false;cvs.classList.remove('is-zoomed');if(sceneBar)sceneBar.classList.add('trk-hidden');setScene('globe');
    hide(document.getElementById('trkDetail'));
    hide(document.getElementById('trkRtd'));
    hide(document.getElementById('intlResult'));
    hide(document.getElementById('planePopup'));
    hide(document.getElementById('globeStatus'));
  });

  /* ─── International tracking helpers (used by the auto worldwide lookup) ─── */
  function intlCountryCode(s){
    if(!s)return '';s=String(s).trim();
    if(/^[A-Za-z]{2}$/.test(s))return s.toUpperCase();
    var M={'united states':'US','united states of america':'US','usa':'US','u.s.a.':'US','u.s.':'US','america':'US',
      'united kingdom':'GB','uk':'GB','great britain':'GB','britain':'GB','england':'GB','scotland':'GB','wales':'GB','northern ireland':'GB',
      'germany':'DE','deutschland':'DE','romania':'RO','france':'FR','spain':'ES','españa':'ES','italy':'IT','italia':'IT',
      'netherlands':'NL','the netherlands':'NL','holland':'NL','belgium':'BE','portugal':'PT','poland':'PL','polska':'PL',
      'sweden':'SE','austria':'AT','switzerland':'CH','greece':'GR','turkey':'TR','türkiye':'TR','turkiye':'TR',
      'china':'CN',"people's republic of china":'CN','prc':'CN','hong kong':'HK','hongkong':'HK','macau':'MO','macao':'MO','taiwan':'TW',
      'japan':'JP','south korea':'KR','korea':'KR','korea, republic of':'KR','republic of korea':'KR','north korea':'KP',
      'canada':'CA','australia':'AU','new zealand':'NZ','brazil':'BR','brasil':'BR','mexico':'MX','méxico':'MX',
      'lebanon':'LB','united arab emirates':'AE','uae':'AE','u.a.e.':'AE','emirates':'AE','saudi arabia':'SA','ksa':'SA',
      'qatar':'QA','kuwait':'KW','bahrain':'BH','oman':'OM','yemen':'YE','jordan':'JO','iraq':'IQ','iran':'IR','syria':'SY',
      'palestine':'PS','egypt':'EG','morocco':'MA','tunisia':'TN','algeria':'DZ','libya':'LY','sudan':'SD',
      'denmark':'DK','norway':'NO','finland':'FI','iceland':'IS','ireland':'IE','luxembourg':'LU','monaco':'MC','malta':'MT',
      'czech republic':'CZ','czechia':'CZ','hungary':'HU','bulgaria':'BG','croatia':'HR','slovakia':'SK','slovenia':'SI',
      'serbia':'RS','bosnia and herzegovina':'BA','bosnia':'BA','north macedonia':'MK','macedonia':'MK','montenegro':'ME',
      'albania':'AL','kosovo':'XK','ukraine':'UA','belarus':'BY','moldova':'MD','russia':'RU','russian federation':'RU',
      'lithuania':'LT','latvia':'LV','estonia':'EE','georgia':'GE','armenia':'AM','azerbaijan':'AZ','kazakhstan':'KZ',
      'uzbekistan':'UZ','turkmenistan':'TM','kyrgyzstan':'KG','tajikistan':'TJ','afghanistan':'AF','pakistan':'PK',
      'india':'IN','bangladesh':'BD','sri lanka':'LK','nepal':'NP','bhutan':'BT','maldives':'MV','myanmar':'MM','burma':'MM',
      'singapore':'SG','malaysia':'MY','thailand':'TH','indonesia':'ID','vietnam':'VN','viet nam':'VN','philippines':'PH',
      'cambodia':'KH','laos':'LA','brunei':'BN','mongolia':'MN','timor-leste':'TL','east timor':'TL',
      'south africa':'ZA','nigeria':'NG','kenya':'KE','ethiopia':'ET','ghana':'GH','tanzania':'TZ','uganda':'UG',
      'ivory coast':'CI',"cote d'ivoire":'CI',"côte d'ivoire":'CI','senegal':'SN','cameroon':'CM','angola':'AO',
      'zimbabwe':'ZW','zambia':'ZM','mozambique':'MZ','botswana':'BW','namibia':'NA','rwanda':'RW','mauritius':'MU',
      'madagascar':'MG','democratic republic of the congo':'CD','dr congo':'CD','congo':'CG','mali':'ML','burkina faso':'BF',
      'cyprus':'CY','argentina':'AR','chile':'CL','colombia':'CO','peru':'PE','venezuela':'VE','ecuador':'EC',
      'bolivia':'BO','paraguay':'PY','uruguay':'UY','guyana':'GY','suriname':'SR','panama':'PA','costa rica':'CR',
      'guatemala':'GT','honduras':'HN','el salvador':'SV','nicaragua':'NI','cuba':'CU','dominican republic':'DO',
      'haiti':'HT','jamaica':'JM','trinidad and tobago':'TT','bahamas':'BS','barbados':'BB','puerto rico':'PR',
      'fiji':'FJ','papua new guinea':'PG','liechtenstein':'LI','san marino':'SM','andorra':'AD','gibraltar':'GI'};
    return M[s.toLowerCase()]||'';
  }
  function intlFlag(s){
    var cc=intlCountryCode(s);
    if(!cc)return '';
    return String.fromCodePoint(0x1F1E6+(cc.charCodeAt(0)-65),0x1F1E6+(cc.charCodeAt(1)-65));
  }
  var INTL_CODE_NAMES={AD:'Andorra',AE:'UAE',AF:'Afghanistan',AG:'Antigua & Barbuda',AI:'Anguilla',AL:'Albania',AM:'Armenia',AO:'Angola',
    AR:'Argentina',AT:'Austria',AU:'Australia',AW:'Aruba',AZ:'Azerbaijan',BA:'Bosnia & Herzegovina',BB:'Barbados',BD:'Bangladesh',
    BE:'Belgium',BF:'Burkina Faso',BG:'Bulgaria',BH:'Bahrain',BI:'Burundi',BJ:'Benin',BM:'Bermuda',BN:'Brunei',BO:'Bolivia',
    BR:'Brazil',BS:'Bahamas',BT:'Bhutan',BW:'Botswana',BY:'Belarus',BZ:'Belize',CA:'Canada',CD:'DR Congo',CF:'Central African Rep.',
    CG:'Congo',CH:'Switzerland',CI:"Côte d'Ivoire",CL:'Chile',CM:'Cameroon',CN:'China',CO:'Colombia',CR:'Costa Rica',CU:'Cuba',
    CV:'Cape Verde',CY:'Cyprus',CZ:'Czechia',DE:'Germany',DJ:'Djibouti',DK:'Denmark',DM:'Dominica',DO:'Dominican Rep.',DZ:'Algeria',
    EC:'Ecuador',EE:'Estonia',EG:'Egypt',ER:'Eritrea',ES:'Spain',ET:'Ethiopia',FI:'Finland',FJ:'Fiji',FK:'Falkland Is.',FM:'Micronesia',
    FO:'Faroe Is.',FR:'France',GA:'Gabon',GB:'United Kingdom',GD:'Grenada',GE:'Georgia',GF:'French Guiana',GG:'Guernsey',GH:'Ghana',
    GI:'Gibraltar',GL:'Greenland',GM:'Gambia',GN:'Guinea',GP:'Guadeloupe',GQ:'Eq. Guinea',GR:'Greece',GT:'Guatemala',GU:'Guam',
    GW:'Guinea-Bissau',GY:'Guyana',HK:'Hong Kong',HN:'Honduras',HR:'Croatia',HT:'Haiti',HU:'Hungary',ID:'Indonesia',IE:'Ireland',
    IM:'Isle of Man',IN:'India',IQ:'Iraq',IR:'Iran',IS:'Iceland',IT:'Italy',JE:'Jersey',JM:'Jamaica',JO:'Jordan',
    JP:'Japan',KE:'Kenya',KG:'Kyrgyzstan',KH:'Cambodia',KI:'Kiribati',KM:'Comoros',KN:'St Kitts & Nevis',KP:'North Korea',
    KR:'South Korea',KW:'Kuwait',KY:'Cayman Is.',KZ:'Kazakhstan',LA:'Laos',LB:'Lebanon',LC:'St Lucia',LI:'Liechtenstein',
    LK:'Sri Lanka',LR:'Liberia',LS:'Lesotho',LT:'Lithuania',LU:'Luxembourg',LV:'Latvia',LY:'Libya',MA:'Morocco',MC:'Monaco',
    MD:'Moldova',ME:'Montenegro',MG:'Madagascar',MH:'Marshall Is.',MK:'North Macedonia',ML:'Mali',MM:'Myanmar',MN:'Mongolia',
    MO:'Macau',MQ:'Martinique',MR:'Mauritania',MT:'Malta',MU:'Mauritius',MV:'Maldives',MW:'Malawi',MX:'Mexico',MY:'Malaysia',
    MZ:'Mozambique',NA:'Namibia',NC:'New Caledonia',NE:'Niger',NG:'Nigeria',NI:'Nicaragua',NL:'Netherlands',NO:'Norway',
    NP:'Nepal',NZ:'New Zealand',OM:'Oman',PA:'Panama',PE:'Peru',PF:'French Polynesia',PG:'Papua New Guinea',PH:'Philippines',
    PK:'Pakistan',PL:'Poland',PR:'Puerto Rico',PS:'Palestine',PT:'Portugal',PY:'Paraguay',QA:'Qatar',RE:'Réunion',RO:'Romania',
    RS:'Serbia',RU:'Russia',RW:'Rwanda',SA:'Saudi Arabia',SB:'Solomon Is.',SC:'Seychelles',SD:'Sudan',SE:'Sweden',SG:'Singapore',
    SI:'Slovenia',SK:'Slovakia',SL:'Sierra Leone',SM:'San Marino',SN:'Senegal',SO:'Somalia',SR:'Suriname',SS:'South Sudan',
    ST:'São Tomé',SV:'El Salvador',SY:'Syria',SZ:'Eswatini',TC:'Turks & Caicos',TD:'Chad',TG:'Togo',TH:'Thailand',TJ:'Tajikistan',
    TL:'Timor-Leste',TM:'Turkmenistan',TN:'Tunisia',TO:'Tonga',TR:'Turkey',TT:'Trinidad & Tobago',TW:'Taiwan',TZ:'Tanzania',
    UA:'Ukraine',UG:'Uganda',US:'United States',UY:'Uruguay',UZ:'Uzbekistan',VA:'Vatican City',VC:'St Vincent',VE:'Venezuela',
    VG:'British Virgin Is.',VI:'US Virgin Is.',VN:'Vietnam',VU:'Vanuatu',WS:'Samoa',XK:'Kosovo',YE:'Yemen',YT:'Mayotte',
    ZA:'South Africa',ZM:'Zambia',ZW:'Zimbabwe'};
  function intlCountryName(s){
    if(!s)return '—';s=String(s).trim();
    if(/^[A-Za-z]{2}$/.test(s))return INTL_CODE_NAMES[s.toUpperCase()]||s.toUpperCase();
    return s;
  }
  /* ─── Full ISO-3166 country coordinate database [lon,lat] — so the globe plots ANY destination
     accurately worldwide (the old ~70-country list silently fell back to Lebanon for the rest). ─── */
  var ISO_COORD={
    AD:[1.5,42.5],AE:[54,24],AF:[66,33],AG:[-61.8,17.1],AI:[-63.1,18.2],AL:[20,41],AM:[45,40],AO:[17.8,-11.2],
    AR:[-64,-34],AT:[14,47.5],AU:[134,-25],AW:[-69.97,12.5],AZ:[47.5,40.3],BA:[18,44],BB:[-59.5,13.2],BD:[90,24],
    BE:[4.5,50.6],BF:[-1.5,12.3],BG:[25,43],BH:[50.5,26],BI:[29.9,-3.4],BJ:[2.3,9.3],BM:[-64.75,32.3],BN:[114.7,4.5],
    BO:[-64,-17],BR:[-53,-10],BS:[-77.4,24.2],BT:[90.4,27.4],BW:[24,-22],BY:[28,53.7],BZ:[-88.5,17.2],CA:[-96,60],
    CD:[23,-2.9],CF:[20.9,6.6],CG:[15.8,-0.7],CH:[8.2,46.8],CI:[-5.5,7.5],CL:[-71,-35],CM:[12.4,5.7],CN:[104,35],
    CO:[-73,4],CR:[-84,10],CU:[-79,21.5],CV:[-24,16],CY:[33,35],CZ:[15.5,49.8],DE:[10.4,51.2],DJ:[42.6,11.6],
    DK:[10,56],DM:[-61.4,15.4],DO:[-70.7,19],DZ:[2.6,28],EC:[-78.5,-1.5],EE:[25.8,58.7],EG:[30,27],ER:[39,15.2],
    ES:[-3.7,40.3],ET:[40,8],FI:[26,64],FJ:[178,-17.8],FK:[-59,-51.7],FM:[150.5,7.4],FO:[-6.9,62],FR:[2.5,46.6],
    GA:[11.6,-0.6],GB:[-1.5,53],GD:[-61.7,12.1],GE:[43.4,42.2],GF:[-53,4],GG:[-2.6,49.5],GH:[-1.2,7.9],GI:[-5.35,36.1],
    GL:[-42,72],GM:[-15.4,13.4],GN:[-10.9,9.9],GP:[-61.5,16.2],GQ:[10.3,1.6],GR:[22,39.5],GT:[-90.4,15.5],GU:[144.8,13.4],
    GW:[-15,12],GY:[-58.9,4.9],HK:[114.1,22.3],HN:[-86.5,14.8],HR:[15.5,45.1],HT:[-72.3,19],HU:[19.5,47.2],ID:[113,-2.5],
    IE:[-8,53.2],IM:[-4.5,54.2],IN:[78,22],IQ:[44,33],IR:[53,32],IS:[-19,65],IT:[12.5,42.8],JE:[-2.1,49.2],
    JM:[-77.3,18.1],JO:[36.5,31],JP:[138,36],KE:[38,0],KG:[75,41.5],KH:[105,12.5],KI:[-157.4,1.9],KM:[43.3,-11.6],
    KN:[-62.7,17.3],KP:[127.5,40],KR:[127.8,36.5],KW:[47.7,29.3],KY:[-81.3,19.3],KZ:[67,48],LA:[103,18.5],LB:[35.5,33.9],
    LC:[-60.97,13.9],LI:[9.55,47.16],LK:[80.7,7.8],LR:[-9.4,6.4],LS:[28.2,-29.6],LT:[24,55.2],LU:[6.1,49.8],LV:[25,56.9],
    LY:[17,27],MA:[-6,32],MC:[7.42,43.74],MD:[28.5,47.2],ME:[19.3,42.8],MG:[46.7,-19],MH:[171,7.1],MK:[21.7,41.6],
    ML:[-3.5,17.6],MM:[96,21],MN:[105,46.8],MO:[113.5,22.2],MQ:[-61,14.6],MR:[-10.9,20.3],MT:[14.4,35.9],MU:[57.5,-20.3],
    MV:[73.4,3.2],MW:[34.3,-13.3],MX:[-102,23.6],MY:[110,4],MZ:[35.5,-18.7],NA:[17.2,-22],NC:[165.5,-21.3],NE:[8,17.6],
    NG:[8,9.6],NI:[-85,12.9],NL:[5.5,52.2],NO:[9,61.5],NP:[84,28.2],NZ:[172,-41],OM:[56,21],PA:[-80,8.5],PE:[-75,-10],
    PF:[-149.4,-17.7],PG:[144.3,-6.3],PH:[122,12.9],PK:[69,30],PL:[19.4,52],PR:[-66.5,18.2],PS:[35.2,31.9],PT:[-8,39.6],
    PY:[-58,-23.4],QA:[51.2,25.3],RE:[55.5,-21.1],RO:[25,45.9],RS:[20.8,44],RU:[90,62],RW:[29.9,-2],SA:[45,24],
    SB:[160,-9.6],SC:[55.5,-4.6],SD:[30,15.6],SE:[15,62],SG:[103.8,1.35],SI:[14.8,46.1],SK:[19.5,48.7],SL:[-11.8,8.5],
    SM:[12.46,43.94],SN:[-14.5,14.5],SO:[46,5],SR:[-56,4],SS:[31,7],ST:[6.6,0.2],SV:[-88.9,13.8],SY:[38,35],SZ:[31.5,-26.5],
    TC:[-71.8,21.7],TD:[18.7,15.5],TG:[0.9,8.6],TH:[101,15],TJ:[71,38.8],TL:[125.6,-8.8],TM:[59,39],TN:[9.5,34],
    TO:[-175.2,-21.2],TR:[35,39],TT:[-61.3,10.5],TW:[121,23.8],TZ:[35,-6.4],UA:[32,49],UG:[32.3,1.3],US:[-98,39],
    UY:[-56,-33],UZ:[63,41.5],VA:[12.45,41.9],VC:[-61.2,13.2],VE:[-66.5,7],VG:[-64.6,18.4],VI:[-64.8,17.7],VN:[106,16],
    VU:[167.5,-16],WS:[-172.1,-13.8],XK:[20.9,42.6],YE:[48,15.5],YT:[45.2,-12.8],ZA:[25,-29],ZM:[27.8,-13.5],ZW:[29.8,-19]
  };
  /* Resolve any country name OR ISO code → [lon,lat]. Order: ISO map → legacy COUNTRY name map → display-name map. */
  function resolveCoords(s){
    if(!s)return null;s=String(s).trim();if(!s)return null;
    var cc=/^[A-Za-z]{2}$/.test(s)?s.toUpperCase():intlCountryCode(s);
    if(cc&&ISO_COORD[cc])return ISO_COORD[cc];
    if(COUNTRY[s])return COUNTRY[s];
    var nm=intlCountryName(s);
    if(COUNTRY[nm])return COUNTRY[nm];
    return null;
  }
  /* Great-circle distance between two countries (now resolves ANY country). */
  function intlDistance(a,b){
    var ca=resolveCoords(a),cb=resolveCoords(b);
    if(!ca||!cb)return null;
    var R=6371,r=function(d){return d*Math.PI/180;};
    var dLat=r(cb[1]-ca[1]),dLon=r(cb[0]-ca[0]);
    var x=Math.sin(dLat/2)*Math.sin(dLat/2)+Math.cos(r(ca[1]))*Math.cos(r(cb[1]))*Math.sin(dLon/2)*Math.sin(dLon/2);
    var km=Math.round(2*R*Math.asin(Math.min(1,Math.sqrt(x))));
    return km>50?km:null;
  }
  function intlRelTime(days){
    if(days==null)return '';
    if(days<=0)return 'Updated today';
    if(days===1)return 'Updated yesterday';
    return 'Updated '+days+' days ago';
  }
  /* 17TRACK milestone key_stage → friendly label */
  function intlMilestoneLabel(s){
    var M={InfoReceived:'Info Received',PickedUp:'Picked Up',Departure:'Departed Origin',Arrival:'Arrived Destination',
      AvailableForPickup:'Available for Pickup',OutForDelivery:'Out for Delivery',Delivered:'Delivered',
      Returning:'Returning to Sender',Returned:'Returned',Exception:'Exception'};
    if(M[s])return M[s];
    return String(s||'Update').replace(/([a-z])([A-Z])/g,'$1 $2').replace(/_/g,' ');
  }
  function renderIntlResult(data){
    var ci=CARRIERS[data.carrier]||{name:'',logo:''};
    /* Prefer the REAL carrier name from 17TRACK (e.g. "DHL Paket · Romania Post") over our logo label. */
    var cname=data.carrier_name||ci.name||'Carrier';
    var statusText=data.statusText||'In Transit';
    var prog=(data.progress!=null)?data.progress:(data.status==='delivered'?5:2);
    var badgeCls=data.status==='delivered'?'is-delivered':((data.status==='exception'||data.status==='failed_attempt')?'is-exception':'');
    var h='<div class="trk-intl-card">';
    /* Header */
    h+='<div class="trk-intl-top">';
    if(ci.logo)h+='<img src="'+ci.logo+'" alt="'+esc(cname)+'" class="trk-intl-top__logo" onerror="this.style.display=\'none\'">';
    h+='<div class="trk-intl-top__info"><div class="trk-intl-top__name">'+esc(cname)+'</div><div class="trk-intl-top__num">'+esc(data.tracking_number||'')+'</div></div>';
    h+='<div class="trk-intl-top__badge '+badgeCls+'">'+esc(statusText)+'</div></div>';
    /* Latest update highlight */
    if(data.latest&&(data.latest.description||data.latest.location)){
      var rel=intlRelTime(data.last_update_days);
      h+='<div class="trk-intl-latest">'+
        '<div class="trk-intl-latest__body"><div class="trk-intl-latest__k">Latest Update</div>'+
        '<div class="trk-intl-latest__txt">'+esc(data.latest.description||'In transit')+'</div>'+
        '<div class="trk-intl-latest__meta">'+[data.latest.location?esc(intlCountryName(data.latest.location)):'',rel,data.signatory?'Signed by '+esc(data.signatory):''].filter(Boolean).join(' · ')+'</div>'+
        '</div></div>';
    }
    /* Route */
    if(data.origin||data.destination){
      h+='<div class="trk-intl-route">';
      h+='<div class="trk-intl-route__pt"><div class="trk-intl-route__flag">'+intlFlag(data.origin)+'</div><div class="trk-intl-route__c">'+esc(intlCountryName(data.origin))+'</div>'+(data.origin_city?'<div class="trk-intl-route__city">'+esc(data.origin_city)+'</div>':'')+'<div class="trk-intl-route__l">Origin</div></div>';
      h+='<div class="trk-intl-route__line"><span>&rarr;</span></div>';
      h+='<div class="trk-intl-route__pt"><div class="trk-intl-route__flag">'+intlFlag(data.destination)+'</div><div class="trk-intl-route__c">'+esc(intlCountryName(data.destination))+'</div>'+(data.destination_city?'<div class="trk-intl-route__city">'+esc(data.destination_city)+'</div>':'')+'<div class="trk-intl-route__l">Destination</div></div>';
      h+='</div>';
    }
    /* Progress bar */
    var PL=['Info','In Transit','Arrived','Out','Delivered'];
    h+='<div class="trk-intl-prog">';
    for(var i=1;i<=5;i++){
      var on=prog>=i,done=(i===5&&prog>=5);
      h+='<div class="trk-intl-prog__seg'+(on?' on':'')+(done?' done':'')+'"><div class="trk-intl-prog__bar"></div><div class="trk-intl-prog__lbl">'+PL[i-1]+'</div></div>';
    }
    h+='</div>';
    /* Meta tiles: transit · day-of-journey · weight · pieces · size · ETA window */
    var tiles=[];
    if(data.transit_days!=null)tiles.push(['In Transit',data.transit_days+' day'+(data.transit_days===1?'':'s'),'']);
    if(data.days_after_order!=null)tiles.push(['Journey','Day '+data.days_after_order,'']);
    var dist=intlDistance(data.origin,data.destination);
    if(dist)tiles.push(['Distance',dist.toLocaleString()+' km','']);
    if(data.weight)tiles.push(['Weight',esc(String(data.weight))+' kg','']);
    if(data.pieces)tiles.push(['Pieces',esc(String(data.pieces)),'']);
    if(data.dimensions)tiles.push(['Size',esc(String(data.dimensions)),'']);
    var etaTxt=(data.eta_from&&data.eta_to&&data.eta_from!==data.eta_to)?(fmtShort(data.eta_from)+' – '+fmtShort(data.eta_to)):(data.eta?fmtFull(data.eta):(data.status==='delivered'?'Delivered':'In transit'));
    tiles.push(['Est. Delivery',etaTxt,'gold']);
    h+='<div class="trk-intl-metarow">';
    tiles.forEach(function(t){h+='<div class="trk-intl-metarow__c"><div class="trk-intl-metarow__k">'+t[0]+'</div><div class="trk-intl-metarow__v '+t[2]+'">'+t[1]+'</div></div>';});
    h+='</div>';
    /* Extra line: service type + signed-by (on delivery) */
    var extras=[];
    if(data.service)extras.push(esc(data.service));
    if(data.signatory)extras.push('Signed by '+esc(data.signatory));
    if(data.reference)extras.push('# '+esc(data.reference));
    if(extras.length)h+='<div class="trk-intl-extras">'+extras.join('<span class="trk-intl-extras__sep">·</span>')+'</div>';
    /* Carrier "tip" / official note (issue explanations) */
    if(data.provider_tip)h+='<div class="trk-intl-tip">'+esc(data.provider_tip)+'</div>';
    /* Carrier contact — official tracking site + phone */
    var pc=data.primary_carrier;
    if(pc&&(pc.url||pc.tel)){
      h+='<div class="trk-intl-contact">';
      if(pc.url)h+='<a class="trk-intl-contact__btn" href="'+esc(pc.url)+'" target="_blank" rel="noopener">Track on '+esc(pc.name||'carrier')+'</a>';
      if(pc.tel)h+='<a class="trk-intl-contact__btn" href="tel:'+esc(String(pc.tel).replace(/[^+\d]/g,''))+'">'+esc(pc.tel)+'</a>';
      h+='</div>';
    }
    /* Milestone journey — the carrier's key stages with timestamps (clean summary above the full log) */
    if(data.milestone&&data.milestone.length){
      h+='<div class="trk-intl-evh">Journey Milestones</div>';
      h+='<div class="trk-journey">';
      data.milestone.forEach(function(m){
        h+='<div class="trk-journey__row"><div class="trk-journey__ic"></div>'+
          '<div class="trk-journey__txt"><div class="trk-journey__stage">'+esc(intlMilestoneLabel(m.stage))+'</div>'+
          (m.date?'<div class="trk-journey__date">'+fmtDateTime(m.date)+'</div>':'')+'</div></div>';
      });
      h+='</div>';
    }
    /* Carrier legs — every courier that handled the parcel (origin → cross-border → last mile) */
    if(data.carriers&&data.carriers.length>1){
      h+='<div class="trk-intl-evh">Carriers Handling This Parcel</div>';
      h+='<div class="trk-legs">';
      data.carriers.forEach(function(c){
        h+='<div class="trk-leg"><div class="trk-leg__flag">'+(c.country?intlFlag(c.country):'')+'</div>'+
          '<div class="trk-leg__info"><div class="trk-leg__name">'+esc(c.name)+'</div>'+
          (c.country?'<div class="trk-leg__sub">'+esc(intlCountryName(c.country))+'</div>':'')+'</div>'+
          (c.events?'<div class="trk-leg__scans">'+c.events+' scan'+(c.events===1?'':'s')+'</div>':'')+'</div>';
      });
      h+='</div>';
    }
    /* Events */
    h+='<div class="trk-intl-evh">Full Tracking History</div>';
    if(data.events&&data.events.length){
      data.events.forEach(function(ev){
        h+='<div class="trk-event"><div class="trk-event__dot"></div><div class="trk-event__info">';
        if(ev.status)h+='<div class="trk-event__status">'+esc(ev.status)+'</div>';
        var sub=[];
        var place=ev.city||(ev.country?intlCountryName(ev.country):(ev.location?intlCountryName(ev.location):''));
        var fl=ev.country?intlFlag(ev.country):(ev.location&&/^[A-Za-z]{2}$/.test(ev.location)?intlFlag(ev.location):'');
        if(place)sub.push((fl?fl+' ':'')+esc(place));
        if(ev.carrier)sub.push('<span class="trk-event__carrier">'+esc(ev.carrier)+'</span>');
        if(sub.length)h+='<div class="trk-event__loc">'+sub.join('&nbsp;·&nbsp;')+'</div>';
        if(ev.date)h+='<div class="trk-event__date">'+fmtDateTime(ev.date)+'</div>';
        h+='</div></div>';
      });
    }else{
      var msg=data.pending
        ?"We've started tracking this parcel. The carrier's first scan usually appears within a minute — check back shortly."
        :data.no_api
        ?'Tracking updates will appear here as your package moves through the delivery network.'
        :'No tracking events yet — check back soon.';
      h+='<div class="trk-events__empty">'+msg+'</div>';
    }
    h+='</div>';
    var el=document.getElementById('intlResult');
    el.innerHTML=h;
    show(el);
  }

  /* Auto-fetch the order's live worldwide tracking — the customer never types a number, we show it. */
  function autoIntl(num,carrier){
    var el=document.getElementById('intlResult');
    if(!el)return;
    el.innerHTML='<div class="trk-intl-card"><div class="trk-events__empty">Loading your live worldwide tracking…</div></div>';
    show(el);
    fetch(WORKER+'/track-intl?num='+encodeURIComponent(num)+'&carrier='+encodeURIComponent(carrier||''))
    .then(function(r){return r.json();})
    .then(function(data){
      if(data&&!data.error){renderIntlResult(data);}
      else{el.innerHTML='<div class="trk-intl-card"><div class="trk-events__empty">Your parcel is on its way. Live carrier updates will appear here as it’s scanned.</div></div>';}
    })
    .catch(function(){el.innerHTML='<div class="trk-intl-card"><div class="trk-events__empty">Couldn’t load live tracking right now — please try again shortly.</div></div>';});
  }

  /* ─── Deep link (?order=1234) and the remembered order ───
     ?order= wins. The email comes from the logged-in customer, else from this device's last successful lookup
     of the SAME order. With neither, we only prefill. A remembered order restores without scrolling the page. */
  (function(){
    var q; try{ q=new URLSearchParams(location.search).get('order'); }catch(e){ q=null; }
    var last=recall();
    if(q){
      q=String(q).replace(/[^0-9A-Za-z-]/g,'').slice(0,20); if(!q) return;
      numEl.value=q;
      if(!mailEl.value&&last&&String(last.n)===q) mailEl.value=last.e;
      if(mailEl.value) track(q,mailEl.value.trim(),{noScroll:false});
    }else if(last){
      numEl.value=last.n; if(!mailEl.value) mailEl.value=last.e;
      track(String(last.n),mailEl.value.trim(),{noScroll:true,restored:true});
    }
  })();

  /* ─── Zoom buttons ─── */
  var _zi=document.getElementById('globeZoomIn'),_zo=document.getElementById('globeZoomOut');
  if(_zi)_zi.addEventListener('click',function(){zoomBy(1.3);});
  if(_zo)_zo.addEventListener('click',function(){zoomBy(1/1.3);});

  /* Reset the globe to its home view (clears any stale zoom/lock from a previous track). */
  function globeHome(){
    planeProgress=0;targetProgress=0;DEST=null;ARC=[];sameCountry=false;
    targetR=R;currentStage=-1;currentData=null;userMoved=false;
    lockedY=HOME.lon*Math.PI/180;lockedX=HOME.lat*Math.PI/180;
    var gs=document.getElementById('globeStatus');if(gs)gs.classList.add('trk-hidden');
  }

})();
